import React, { useEffect, useRef, useState } from "react";
import "./Reservation.css";
import AppWrapper from "../AppWrapper";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Card,
  InlineGrid,
  Layout,
  Page,
  Text,
  Badge,
  Button,
  BlockStack,
  Tooltip,
  ResourceList,
  ResourceItem,
  Icon,
  Modal,
  TextField,
  FormLayout,
  Select,
  Divider,
  DropZone,
  InlineStack,
  Banner,
  Checkbox,
} from "@shopify/polaris";
import {
  ExchangeIcon,
  IncomingIcon,
  LinkIcon,
  OutgoingIcon,
  PageDownIcon,
} from "@shopify/polaris-icons";
import PersonIcon from "@mui/icons-material/Person";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import FrontLoaderIcon from "@mui/icons-material/FrontLoader";
import { Chip } from "@mui/material";
import supabase from "../../supabase-client";
import PaymentClabe from "../CustomComponents/PaymentClabe";
import moment from "moment";
import {
  formatPrice,
  formatDate,
  formatFriendlyDate,
  normPlate,
  formatPlate,
} from "../../utility/funcs";
import { hoursOfDay } from "../../utility/GlobalVariables";
import { getInvoicesForReservation, invoiceDue } from "../../utility/invoicing";
import {
  getReservationTime,
  calculateReservationTotal,
  clearOpenSectionBillableAmount,
  resyncReservationTotals,
} from "../../utility/ReservationUtilities";
import AddPayment from "../CustomComponents/AddPayment/AddPayment";
import UnappliedPaymentsCard from "../Payments/UnappliedPaymentsCard";
import { getPayoutReceipt } from "../../utility/pagos";
import {
  loadFintocDepositSource,
  originDestination,
  ConfirmDepositReturnModal,
} from "../Payments/FintocDepositReturn";
import {
  loadClipDepositSource,
  loadClipRefund,
  clipRefundOpen,
  ConfirmClipRefundModal,
  ClipRefundStatus,
  CLIP_REFUNDS_ENABLED,
} from "../Payments/ClipDepositReturn";
import {
  CardReturnAccount,
  CardReturnStatus,
  loadCardReturnPayout,
  cardReturnOpen,
} from "../Payments/CardDepositReturn";
import { applyAllocations } from "../../utility/payments";
import { UserAuth } from "../../context/AuthContext";
import PopUpSearch from "../CustomComponents/PopUpSearch/PopUpSearch";
import PopUpAmount from "../CustomComponents/PopUpAmount/PopUpAmount";
import ChangeCarModal from "./ChangeCarModal";
import ChangeOwnerModal from "./ChangeOwnerModal";
import InspectionModal from "./InspectionModal";
import InvoiceModal from "../Invoicing/InvoiceModal";
import InvoiceActionsModal from "../Invoicing/InvoiceActionsModal";
import {
  moveOverpaymentToCredit,
  getCreditBalance,
  bringCreditToReservation,
} from "../../utility/clientCredit";
import {
  WRITE_OFF_PERMISSION,
  markWriteOff,
  clearWriteOff,
} from "../../utility/writeOffs";

// Grace window for undoing a just-recorded action: reverting an entrega/devolución
// (revert_inspection) and deleting a payment (delete_payment) both use it. The
// matching SQL guards are authoritative — keep this in sync with the
// `interval '2 hours'` in both RPCs.
const REVERT_WINDOW_MS = 2 * 60 * 60 * 1000;
// transaction_accounts id of Clip. A Clip deposit is a sale, so it is never a
// manual "return method": it goes back as a refund through pagos-svc.
const CLIP_ACCOUNT_ID = 4;

// reservations.insurance tier → label / coverage description. Shared by the
// Resumen card and the contract PDF so both always say the same thing.
const insuranceLabels = {
  base: "Básico 10%",
  standard: "Estándar 0%",
  premium: "Premium 0%",
  none: "Sin Seguro",
};
const insuranceTexts = {
  base: "Básico - 10% deducible en siniestros, robo y pérdida total se paga el 25% valor factura.",
  standard: "Estándar - 0% deducible en siniestros; robo y pérdida total se paga el 25% valor factura.",
  premium: "Premium - 0% deducible en siniestros, robo y pérdida total.",
  none: "Sin cobertura de seguro.",
};

function Reservation() {
  const { session, claims, hasPermission } = UserAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reservationId = searchParams.get("id");
  const [resDetails, setResDetails] = useState({
    id: undefined,
  });
  const [inspections, setInspections] = useState([]);
  const [payments, setPayments] = useState([]);
  // Client-level payments that paid this reservation's invoices — see
  // loadIndirectPayments. Display-only; deliberately NOT merged into `payments`.
  const [indirectPayments, setIndirectPayments] = useState([]);
  const [paymentsWindow, setPaymentsWindow] = useState({
    active: false,
    isDeposit: false,
  });
  const [charges, setCharges] = useState([]);
  const [chargeModal, setChargeModal] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [newCharge, setNewCharge] = useState({ charge_type: "damage", description: "", amount: "" });
  const [completeModal, setCompleteModal] = useState(false);
  const [extendModal, setExtendModal] = useState(false);
  const [extendApplyNewRate, setExtendApplyNewRate] = useState(false);
  const [extendNewRateDate, setExtendNewRateDate] = useState("");
  const [extendNewRatePrice, setExtendNewRatePrice] = useState("");
  const [extendError, setExtendError] = useState("");
  const [dateEditModal, setDateEditModal] = useState({ open: false, type: "", date: "", hour: "", recalc: true });
  const [additionalDriverModal, setAdditionalDriverModal] = useState(false);
  const [additionalDrivers, setAdditionalDrivers] = useState([]);
  const [extendDate, setExtendDate] = useState("");
  const [extendHour, setExtendHour] = useState("09:00");
  const [customerModal, setCustomerModal] = useState(false);
  const [companyModal, setCompanyModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [refundModal, setRefundModal] = useState(false);
  const [refundAmount, setRefundAmount] = useState("");
  const [refundAccount, setRefundAccount] = useState("");
  const [refundAccounts, setRefundAccounts] = useState([]);
  const [refundSaving, setRefundSaving] = useState(false);
  const [creditModal, setCreditModal] = useState(false);
  const [creditAmount, setCreditAmount] = useState("");
  const [creditSaving, setCreditSaving] = useState(false);
  // External credit (from other reservations) available to apply here.
  const [externalCredit, setExternalCredit] = useState(0);
  // Debt this client carries on OTHER reservations (excludes the current one).
  const [otherDebt, setOtherDebt] = useState({ total: 0, items: [] });
  const [otherDebtOpen, setOtherDebtOpen] = useState(false);
  // Benefits assigned to this reservation's client (shown as badges).
  const [clientBenefits, setClientBenefits] = useState([]);

  // Client profile credit balance — load on mount (and whenever the client
  // changes), not only after refreshData, so the card shows on first open.
  useEffect(() => {
    const entityType = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;
    if (!entityId) {
      setExternalCredit(0);
      return;
    }
    let cancelled = false;
    getCreditBalance(entityType, entityId).then((b) => {
      if (!cancelled) setExternalCredit(b);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resDetails.customer, resDetails.company]);

  useEffect(() => {
    const entityType = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;
    if (!entityId) {
      setClientBenefits([]);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("client_benefits")
        .select("benefit:benefit_id(name, tone, active)")
        .eq("entity_type", entityType)
        .eq("entity_id", entityId);
      if (cancelled) return;
      setClientBenefits((data || []).map((r) => r.benefit).filter((b) => b && b.active));
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resDetails.customer, resDetails.company]);

  useEffect(() => {
    const entityCol = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;
    if (!entityId || !resDetails.id) {
      setOtherDebt({ total: 0, items: [] });
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("reservations")
        .select("id, balance, date_range")
        .eq(entityCol, entityId)
        .neq("id", resDetails.id)
        .gt("balance", 0.005)
        .not("status", "in", "(cancelled,no_show,quotation)");
      if (cancelled) return;
      const items = (data || []).map((r) => ({
        id: r.id,
        balance: r.balance || 0,
        range: r.date_range,
      }));
      const total = items.reduce((s, r) => s + r.balance, 0);
      setOtherDebt({ total: Math.round(total * 100) / 100, items });
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resDetails.id, resDetails.customer, resDetails.company]);
  const [applyCreditModal, setApplyCreditModal] = useState(false);
  const [applyCreditAmount, setApplyCreditAmount] = useState("");
  const [applyCreditSaving, setApplyCreditSaving] = useState(false);
  const [depositCreditModal, setDepositCreditModal] = useState(false);
  const [depositCreditAmount, setDepositCreditAmount] = useState("");
  const [depositCreditSaving, setDepositCreditSaving] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [discountMode, setDiscountMode] = useState("dias"); // "dias" | "monto"
  const [discountDays, setDiscountDays] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [discountReason, setDiscountReason] = useState("");
  const [auditLog, setAuditLog] = useState([]);
  const [auditComment, setAuditComment] = useState("");
  const [resFiles, setResFiles] = useState([]);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [changeCarModal, setChangeCarModal] = useState(false);
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [carHistory, setCarHistory] = useState([]);
  const [inspectionModal, setInspectionModal] = useState({ open: false, type: "checkout" });
  const [revertModal, setRevertModal] = useState({ open: false, type: null, inspectionId: null, busy: false });
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [substituteInvoice, setSubstituteInvoice] = useState(null); // original being re-facturada
  const [issuedInvoices, setIssuedInvoices] = useState([]);
  const [pricePeriods, setPricePeriods] = useState([]);
  const [pricePeriodsError, setPricePeriodsError] = useState("");
  const [changeRateModal, setChangeRateModal] = useState(false);
  const [changeRateForm, setChangeRateForm] = useState({ date: "", price: "", reason: "", wholeReservation: true });
  const [changeRateSaving, setChangeRateSaving] = useState(false);
  const [changeRateError, setChangeRateError] = useState("");
  const [invoiceLoading, setInvoiceLoading] = useState({});
  const [invoiceActions, setInvoiceActions] = useState({ open: false, invoice: null });
  const [emailModal, setEmailModal] = useState({ open: false, invoiceId: null, invoiceNumber: "" });
  const [emailTo, setEmailTo] = useState("");
  const [emailSending, setEmailSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [concilModal, setConcilModal] = useState({ open: false, type: null, item: null, targetId: null });
  const [concilAmount, setConcilAmount] = useState("");
  const [concilSaving, setConcilSaving] = useState(false);
  const [paymentDetail, setPaymentDetail] = useState({ open: false, payment: null, allocations: [], loading: false });
  // Synchronous guard against double-clicks on saveConciliation — the `saving`
  // state doesn't commit until after React's render cycle, so a fast second
  // click can slip past the disabled prop and create duplicate allocations.
  const concilSavingRef = useRef(false);
  // Same guard for the refund and deposit-return modals (they each insert a
  // transaction whose duplicate would inflate the ledger).
  const refundSavingRef = useRef(false);
  const depositReturnSavingRef = useRef(false);
  const [deliveryModal, setDeliveryModal] = useState(false);
  const [deliveryForm, setDeliveryForm] = useState({
    delivery_type: "sucursal",
    delivery_address: "",
    delivery_fee: 500,
    delivery_notes: "",
    return_type: "sucursal",
    return_address: "",
    return_fee: 500,
    return_notes: "",
  });
  const [editTotal, setEditTotal] = useState({
    activated: false,
    key: undefined,
    value: undefined,
    title: undefined,
  });

  useEffect(() => {
    async function getReservationDetails() {
      const { data, error } = await supabase
        .from("reservations")
        .select(
          "*, car(id, color, notes, odometer, plate, vin, year, alegra_item_id, model(*, brand(name))), customer(*), company:companies!company(*), sublease_model:car_models!sublease_model_id(id, name, show_as, brand:car_brands(name)), created_by_user:created_by(name)"
        )
        .eq("id", reservationId)
        .single();
      if (error) {
        console.error(error.message);
        return { success: false, error: error.message };
      }
      setResDetails(data);
    }
    async function getPayments() {
      const { data, error } = await supabase
        .from("transactions")
        .select("*, account(name)")
        .eq("reservation", reservationId)
        .order("created_at", { ascending: false });
      if (error) {
        console.error(error.message);
        return { success: false, error: error.message };
      }
      setPayments(data);
      loadIndirectPayments();
    }

    async function getCharges() {
      const { data } = await supabase
        .from("reservation_charges")
        .select("*")
        .eq("reservation_id", reservationId)
        .order("created_at", { ascending: false });
      if (data) setCharges(data);
    }

    async function getDiscounts() {
      const { data } = await supabase
        .from("reservation_discounts")
        .select("*")
        .eq("reservation_id", reservationId)
        .order("created_at", { ascending: false });
      if (data) setDiscounts(data);
    }

    async function getAuditLog() {
      const { data } = await supabase
        .from("reservation_audit_log")
        .select("*, user:user_id(name)")
        .eq("reservation_id", reservationId)
        .order("created_at", { ascending: false });
      if (data) setAuditLog(data);
    }

    async function getInspections() {
      const { data } = await supabase
        .from("reservation_inspections")
        .select(
          "id, type, odometer, fuel_level, notes, signed_at, signed_by_name, signing_method, signature_image_url, revert_snapshot, recorded_at, created_at, reservation_inspection_photos(file_url, file_name, label)"
        )
        .eq("reservation_id", reservationId)
        .order("created_at", { ascending: true });
      if (data) setInspections(await resolvePhotoUrls(data));
    }

    if (resDetails.id === undefined) {
      getReservationDetails();
      getPayments();
      getCharges();
      getDiscounts();
      getAuditLog();
      getInspections();

      supabase
        .from("reservation_car_changes")
        .select("*")
        .eq("reservation_id", reservationId)
        .order("changed_at", { ascending: false })
        .then(async ({ data }) => {
          if (!data || data.length === 0) return;
          // Look up car plates and models
          const carIds = [...new Set(data.flatMap(ch => [ch.previous_car_id, ch.new_car_id]).filter(Boolean))];
          const { data: cars } = await supabase
            .from("cars")
            .select("id, plate, model(name)")
            .in("id", carIds);
          const carMap = {};
          if (cars) cars.forEach(c => { carMap[c.id] = c; });
          setCarHistory(data.map(ch => {
            const subToFleet = !ch.previous_car_id ? /\[Desde Subarrendado\s+([^\]]+)\]\s*/.exec(ch.reason || "") : null;
            const fleetToSub = !ch.new_car_id ? /\[Subarrendado\s+([^\]]+)\]\s*/.exec(ch.reason || "") : null;
            const tagMatch = subToFleet || fleetToSub;
            return {
              ...ch,
              reason: tagMatch ? (ch.reason || "").replace(tagMatch[0], "").trim() : ch.reason,
              prev_plate: ch.previous_car_id
                ? (carMap[ch.previous_car_id]?.plate || "?")
                : (subToFleet?.[1]?.trim() || "?"),
              prev_model: ch.previous_car_id
                ? (carMap[ch.previous_car_id]?.model?.name || "?")
                : "Subarrendado",
              new_plate: ch.new_car_id
                ? (carMap[ch.new_car_id]?.plate || "?")
                : (fleetToSub?.[1]?.trim() || "?"),
              new_model: ch.new_car_id
                ? (carMap[ch.new_car_id]?.model?.name || "?")
                : "Subarrendado",
            };
          }));
        });

      getInvoicesForReservation(reservationId).then((list) =>
        setIssuedInvoices(list)
      );

      supabase
        .from("reservation_price_periods")
        .select("*, user:created_by(name)")
        .eq("reservation_id", reservationId)
        .order("effective_from", { ascending: false })
        .then(({ data, error }) => {
          if (error) {
            console.error("No se pudieron cargar los periodos de tarifa", error);
            setPricePeriodsError(error.message);
          } else {
            setPricePeriodsError("");
            setPricePeriods(data || []);
          }
        });
    }
  }, [reservationId]);

  const refreshData = async () => {
    const { data } = await supabase
      .from("reservations")
      .select(
        "*, car(id, color, notes, odometer, plate, vin, year, alegra_item_id, model(*, brand(name))), customer(*), company:companies!company(*), sublease_model:car_models!sublease_model_id(id, name, show_as, brand:car_brands(name)), created_by_user:created_by(name)"
      )
      .eq("id", reservationId)
      .single();
    if (data) {
      setResDetails(data);
      // Fetch additional driver names
      if (data.additional_drivers && data.additional_drivers.length > 0) {
        const { data: drivers } = await supabase
          .from("customers")
          .select("id, first_name, last_name")
          .in("id", data.additional_drivers);
        if (drivers) setAdditionalDrivers(drivers);
      } else {
        setAdditionalDrivers([]);
      }
    }

    const { data: txns } = await supabase
      .from("transactions")
      .select("*, account(name)")
      .eq("reservation", reservationId)
      .order("created_at", { ascending: false });
    if (txns) setPayments(txns);

    const { data: chgs } = await supabase
      .from("reservation_charges")
      .select("*")
      .eq("reservation_id", reservationId)
      .order("created_at", { ascending: false });
    if (chgs) setCharges(chgs);

    const { data: discs } = await supabase
      .from("reservation_discounts")
      .select("*")
      .eq("reservation_id", reservationId)
      .order("created_at", { ascending: false });
    if (discs) setDiscounts(discs);

    const { data: logs } = await supabase
      .from("reservation_audit_log")
      .select("*, user:user_id(name)")
      .eq("reservation_id", reservationId)
      .order("created_at", { ascending: false });
    if (logs) setAuditLog(logs);

    const { data: insps } = await supabase
      .from("reservation_inspections")
      .select(
        "id, type, odometer, fuel_level, notes, signed_at, signed_by_name, signing_method, signature_image_url, revert_snapshot, recorded_at, created_at, reservation_inspection_photos(file_url, file_name, label)"
      )
      .eq("reservation_id", reservationId)
      .order("created_at", { ascending: true });
    if (insps) setInspections(await resolvePhotoUrls(insps));

    const { data: carChanges } = await supabase
      .from("reservation_car_changes")
      .select("*")
      .eq("reservation_id", reservationId)
      .order("changed_at", { ascending: false });
    if (carChanges && carChanges.length > 0) {
      const carIds = [...new Set(carChanges.flatMap(ch => [ch.previous_car_id, ch.new_car_id]).filter(Boolean))];
      const { data: cars } = await supabase.from("cars").select("id, plate, model(name)").in("id", carIds);
      const carMap = {};
      if (cars) cars.forEach(c => { carMap[c.id] = c; });
      setCarHistory(carChanges.map(ch => {
        const subToFleet = !ch.previous_car_id ? /\[Desde Subarrendado\s+([^\]]+)\]\s*/.exec(ch.reason || "") : null;
        const fleetToSub = !ch.new_car_id ? /\[Subarrendado\s+([^\]]+)\]\s*/.exec(ch.reason || "") : null;
        const tagMatch = subToFleet || fleetToSub;
        return {
          ...ch,
          reason: tagMatch ? (ch.reason || "").replace(tagMatch[0], "").trim() : ch.reason,
          prev_plate: ch.previous_car_id
            ? (carMap[ch.previous_car_id]?.plate || "?")
            : (subToFleet?.[1]?.trim() || "?"),
          prev_model: ch.previous_car_id
            ? (carMap[ch.previous_car_id]?.model?.name || "?")
            : "Subarrendado",
          new_plate: ch.new_car_id
            ? (carMap[ch.new_car_id]?.plate || "?")
            : (fleetToSub?.[1]?.trim() || "?"),
          new_model: ch.new_car_id
            ? (carMap[ch.new_car_id]?.model?.name || "?")
            : "Subarrendado",
        };
      }));
    } else {
      setCarHistory([]);
    }

    const { data: files } = await supabase
      .from("reservation_files")
      .select("*")
      .eq("reservation_id", reservationId)
      .order("created_at", { ascending: false });
    if (files) setResFiles(files);

    const invoices = await getInvoicesForReservation(reservationId);
    if (invoices) setIssuedInvoices(invoices);

    // Client-level payments applied to those invoices (see loadIndirectPayments).
    await loadIndirectPayments();

    // Never swallow a failure here: the rate-change and date-edit flows resolve
    // the "open section" from this state, so a silently stale pricePeriods lets
    // them target an already-closed section and the DB rejects every retry.
    const { data: periods, error: periodsError } = await supabase
      .from("reservation_price_periods")
      .select("*, user:created_by(name)")
      .eq("reservation_id", reservationId)
      .order("effective_from", { ascending: false });
    if (periodsError) {
      console.error("No se pudieron recargar los periodos de tarifa", periodsError);
      setPricePeriodsError(periodsError.message);
    } else {
      setPricePeriodsError("");
      setPricePeriods(periods || []);
    }

    // Client profile credit (ledger balance) — money explicitly moved "up".
    if (data?.customer || data?.company) {
      const entityType = data.company ? "company" : "customer";
      const entityId = data.company?.id || data.customer?.id;
      setExternalCredit(await getCreditBalance(entityType, entityId));
    } else {
      setExternalCredit(0);
    }
  };

  const uploadFiles = async () => {
    for (const file of filesToUpload) {
      const safeName = file.name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9._-]/g, "_");
      const filePath = `${reservationId}/${Date.now()}_${safeName}`;
      const { error } = await supabase.storage
        .from("reservation-files")
        .upload(filePath, file, { upsert: true });
      if (error) { console.error(error); continue; }
      await supabase.from("reservation_files").insert({
        reservation_id: reservationId,
        file_url: filePath,
        file_name: file.name,
        created_by: session?.user?.id,
      });
    }
    setFilesToUpload([]);
    setFileUploadModal(false);
    await logAudit("file_upload", { count: filesToUpload.length });
    refreshData();
  };

  const copyWhatsApp = () => {
    if (!resDetails.id) return;
    const customer = resDetails.customer;
    const car = resDetails.car;
    const text = [
      `*Reserva #${resDetails.id}*`,
      customer ? `Cliente: ${customer.first_name} ${customer.last_name}` : null,
      car ? `Auto: ${car.model?.brand?.name || ""} ${car.model?.show_as || car.model?.name || ""} (${formatPlate(car.plate)})` : null,
      `Entrega: ${resDetails.date_range?.replace(/[\[\]()]/g, "").split(",")[0]?.replace(/"/g, "").trim() || ""}`,
      `Devolución: ${resDetails.date_range?.replace(/[\[\]()]/g, "").split(",")[1]?.replace(/"/g, "").trim() || ""}`,
      `Total: $${resDetails.total_price?.toLocaleString() || 0}`,
      `Depósito: $${resDetails.deposit?.toLocaleString() || 0}`,
    ].filter(Boolean).join("\n");
    navigator.clipboard.writeText(text).then(() => alert("Copiado al portapapeles"));
  };

  const logAudit = async (action, changes = {}, comment = null) => {
    await supabase.from("reservation_audit_log").insert({
      reservation_id: reservationId,
      user_id: session?.user?.id,
      action,
      changes,
      comment,
    });
  };

  const togglePossibleExtension = async () => {
    const next = !resDetails.possible_extension;
    const { error } = await supabase
      .from("reservations")
      .update({ possible_extension: next })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    await logAudit(
      "possible_extension",
      { possible_extension: next },
      next ? "Marcada como posible extensión" : "Se quitó la posible extensión"
    );
    refreshData();
  };

  const addAuditComment = async () => {
    if (!auditComment.trim()) return;
    await logAudit("comment", {}, auditComment.trim());
    setAuditComment("");
    refreshData();
  };

  const addCharge = async () => {
    const chargeAmount = parseFloat(newCharge.amount) || 0;
    // DB trigger trg_reservation_charges_sync_total bumps reservations.total_price
    // / balance / fully_paid atomically — don't bump from JS or it'd double-count.
    const { error } = await supabase.from("reservation_charges").insert({
      reservation_id: reservationId,
      charge_type: newCharge.charge_type,
      description: newCharge.description,
      amount: chargeAmount,
      created_by: session?.user?.id,
    });
    if (error) {
      alert("Error: " + error.message);
      return;
    }

    setNewCharge({ charge_type: "damage", description: "", amount: "" });
    setChargeModal(false);
    refreshData();
  };

  const deleteCharge = async (chargeId) => {
    // Trigger handles total_price / balance / fully_paid sync.
    await supabase.from("reservation_charges").delete().eq("id", chargeId);
    refreshData();
  };

  const getCompletionBlockers = () => {
    const blockers = [];
    const balance = (resDetails.total_price || 0) - (resDetails.paid || 0);
    if (balance > 0.01) blockers.push(`Saldo pendiente de cobro: ${formatPrice(balance)}`);

    const totalInvoiced = issuedInvoices
      .filter((i) => i.status !== "void")
      .reduce((sum, i) => sum + (i.total || 0) - (i.amount_credited || 0), 0);
    const pendingToInvoice = (resDetails.total_price || 0) - totalInvoiced;
    if (pendingToInvoice > 0.01) blockers.push(`Falta facturar: ${formatPrice(pendingToInvoice)}`);

    const unpaidInvoices = issuedInvoices.filter(
      (i) => i.status !== "void" && invoiceDue(i) > 0.01
    );
    if (unpaidInvoices.length > 0) blockers.push(`Facturas sin pagar: ${unpaidInvoices.map((i) => i.invoice_number).join(", ")}`);

    // Pagos sin conciliar — money on this reservation's income transactions
    // that hasn't been matched to an invoice. Always-block would also reject
    // the legitimate "Mover a Crédito" path (which intentionally restores
    // unallocated_amount as customer credit). Allow up to the overpayment so
    // that case closes cleanly; anything above it means the agent forgot to
    // reconcile a real payment.
    //
    // Refunds also leave a residual unallocated_amount on the original income
    // transaction (a refund is a separate 'refund' row, not an allocation), so
    // refunded cash still shows as unallocated here. recompute_reservation_payments
    // subtracts refunds when computing `paid`, so net them out the same way —
    // otherwise a fully-refunded overcollection nets to 0 yet stays unblockable.
    const overpayment = Math.max(0, (resDetails.paid || 0) - (resDetails.total_price || 0));
    const refundsTotal = payments
      .filter((p) => p.type === "refund")
      .reduce((sum, p) => sum + (p.amount || 0), 0);
    const totalUnallocated = payments
      .filter((p) => !p.isDeposit && (p.unallocated_amount || 0) > 0.01)
      .reduce((sum, p) => sum + (p.unallocated_amount || 0), 0);
    const unconciliated = totalUnallocated - overpayment - refundsTotal;
    if (unconciliated > 0.01) {
      blockers.push(`Pagos sin conciliar: ${formatPrice(unconciliated)}`);
    }

    const depositPaidForBlocker = payments
      .filter((p) => p.isDeposit)
      .reduce((sum, p) => sum + (p.amount || 0), 0);
    if (depositPaidForBlocker > 0 && !resDetails.deposit_returned) blockers.push("Depósito no devuelto");
    if (!resDetails.checked_in) blockers.push("Auto no recibido (check-in pendiente)");

    return blockers;
  };

  const completeReservation = async () => {
    const blockers = getCompletionBlockers();
    if (blockers.length > 0) {
      alert("No se puede completar la reservación:\n\n" + blockers.join("\n"));
      return;
    }
    const { error } = await supabase
      .from("reservations")
      .update({ status: "completed" })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    setCompleteModal(false);
    refreshData();
  };

  const [depositReturnModal, setDepositReturnModal] = useState(false);
  const [depositReturnAccount, setDepositReturnAccount] = useState(null);
  const [depositReturnAccounts, setDepositReturnAccounts] = useState([]);
  // When true, the returnable deposit is sent to the client's credit balance
  // (a client_credit_ledger entry) instead of being paid out to a real account.
  const [depositReturnToCredit, setDepositReturnToCredit] = useState(false);
  // Automatic SPEI return through Fintoc — only when the deposit arrived that way.
  const [fintocSource, setFintocSource] = useState(null);
  const [useFintocReturn, setUseFintocReturn] = useState(false);
  const [fintocConfirmOpen, setFintocConfirmOpen] = useState(false);
  // The SPEI that returned this deposit, if it went out through Fintoc. Its
  // comprobante is Fintoc's own PDF, fetched on demand: the signed URL expires
  // in about an hour, so it is never stored.
  const [returnPayout, setReturnPayout] = useState(null);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  // A deposit CHARGED through Clip goes back as a refund to the same card —
  // marking it returned moves no money (1485, 1561, 1603).
  const [clipSource, setClipSource] = useState(null);
  const [clipConfirmOpen, setClipConfirmOpen] = useState(false);
  const [clipRefund, setClipRefund] = useState(null);
  const [clipRefundTick, setClipRefundTick] = useState(0);
  // ...which for now goes back by SPEI instead, to the payer's CLABE once the
  // bank confirms it is theirs (CardDepositReturn.js).
  const [cardReturn, setCardReturn] = useState({ ready: false, destination: null });
  const [cardConfirmOpen, setCardConfirmOpen] = useState(false);
  const [cardPayout, setCardPayout] = useState(null);

  const openDepositReturn = async () => {
    // Load all available accounts and pre-select the original deposit's account
    // (or first deposit transaction's account if multiple deposits exist).
    const { data: accs } = await supabase
      .from("transaction_accounts")
      .select("id, name, type")
      .order("order", { ascending: true });
    setDepositReturnAccounts(accs || []);

    const { data: depTx } = await supabase
      .from("transactions")
      .select("account")
      .eq("reservation", reservationId)
      .eq("isDeposit", true)
      .order("id", { ascending: true })
      .limit(1)
      .maybeSingle();
    // Never pre-select the internal credit account as a payout method — it's
    // handled by the "enviar a crédito" toggle, not the account dropdown.
    const original = accs?.find((a) => a.id === depTx?.account);
    const firstReal = accs?.find((a) => a.type !== "credit");
    // A Fintoc deposit (account 7) defaults to the automatic option below; if
    // that isn't available, it falls back to a manual SPEI from the usual bank.
    const manualBank = accs?.find((a) => a.type === "bank" && a.id !== 7);
    // Clip (4) is never a manual return method either: picking it only set
    // the flags, with the money still in Clip.
    setDepositReturnAccount(
      original?.id === 7 || original?.id === CLIP_ACCOUNT_ID
        ? manualBank?.id ?? firstReal?.id ?? null
        : original && original.type !== "credit" ? original.id : firstReal?.id ?? null
    );
    setDepositReturnToCredit(false);

    const src = await loadFintocDepositSource(parseInt(reservationId));
    setFintocSource(src);
    // Default to the method the deposit came in by: Fintoc, when it did.
    setUseFintocReturn(!!src);
    setClipSource(await loadClipDepositSource(parseInt(reservationId)));
    setCardReturn({ ready: false, destination: null });

    setDepositReturnModal(true);
  };

  // Runs on mount and again whenever the deposit becomes returned, so the
  // comprobante appears without a reload after a return goes out.
  useEffect(() => {
    if (!reservationId || !resDetails?.deposit_returned) {
      setReturnPayout(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("payouts")
        .select("id, amount_cents, clabe, resolved_at")
        .in("payable_kind", ["deposit_return", "card_deposit_return"])
        .eq("payable_id", String(reservationId))
        .eq("status", "succeeded")
        .order("resolved_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (!cancelled) setReturnPayout(data || null);
    })();
    return () => { cancelled = true; };
  }, [reservationId, resDetails?.deposit_returned]);

  useEffect(() => {
    if (!reservationId) return undefined;
    let cancelled = false;
    loadClipRefund(parseInt(reservationId)).then((r) => { if (!cancelled) setClipRefund(r); });
    return () => { cancelled = true; };
  }, [reservationId, resDetails?.deposit_returned, clipRefundTick]);
  useEffect(() => {
    if (!reservationId) return undefined;
    let cancelled = false;
    loadCardReturnPayout(parseInt(reservationId)).then((p) => { if (!cancelled) setCardPayout(p); });
    return () => { cancelled = true; };
  }, [reservationId, resDetails?.deposit_returned, clipRefundTick]);
  // A refund or a SPEI on its way hides "Devolver Depósito": a second one
  // would be refused anyway, and the Depósito card says where it stands.
  const clipRefundPending = clipRefundOpen(clipRefund) || cardReturnOpen(cardPayout);

  const openReturnReceipt = async () => {
    if (!returnPayout) return;
    setLoadingReceipt(true);
    try {
      const { download_url } = await getPayoutReceipt(returnPayout.id);
      window.open(download_url, "_blank", "noopener");
    } catch (err) {
      alert("No se pudo obtener el comprobante: " + (err.message || err));
    } finally {
      setLoadingReceipt(false);
    }
  };

  const existingChargesTotal = charges.reduce((sum, c) => sum + c.amount, 0);
  // Charges are already added to total_price by addCharge / auto-fuel flows,
  // so pendingBalance already reflects them. Don't double-count.
  const pendingBalance = Math.max(0, (resDetails.total_price || 0) - (resDetails.paid || 0));
  const totalDeductions = pendingBalance;
  // Use ACTUAL deposit collected (sum of deposit transactions), not the
  // agreed-upon amount stored in `reservations.deposit` — those can diverge.
  const depositTxns = payments.filter((p) => p.isDeposit);
  const depositPaid = depositTxns.reduce((sum, p) => sum + (p.amount || 0), 0);
  const depositToReturn = Math.max(0, depositPaid - totalDeductions);
  // The client owes at least the whole deposit: nothing goes back, the deposit
  // is charged in full against the balance. Same flow, worded as a charge.
  const depositFullyCharged = depositPaid > 0 && pendingBalance > 0 && depositToReturn <= 0;
  const depositChargeAmount = Math.min(pendingBalance, depositPaid);
  const depositActionLabel = depositFullyCharged ? "Cobrar Garantía" : "Devolver Depósito";
  const fintocReturnEligible =
    // No permission gate, by decision: any staff member may return a deposit
    // that arrived through Fintoc. The protection lives in WHERE it can go —
    // the account it came from, or a saved account the bank has verified —
    // which pagos-svc must re-derive server-side, never trust from here.
    !!fintocSource &&
    depositToReturn > 0 &&
    Math.round(depositToReturn * 100) <= fintocSource.cents;
  const fintocDestination = originDestination(fintocSource);
  const fintocActive = fintocReturnEligible && useFintocReturn && !depositReturnToCredit;
  // Same idea for Clip: the whole amount must fit in the one charge a refund
  // can reference; anything else is returned by hand (without a Clip option).
  const clipReturnEligible =
    CLIP_REFUNDS_ENABLED &&
    !fintocReturnEligible &&
    !!clipSource &&
    depositToReturn > 0 &&
    Math.round(depositToReturn * 100) <= clipSource.maxCents;
  const clipActive = clipReturnEligible && !depositReturnToCredit;
  // While Clip refunds are off, a Clip deposit goes back by SPEI. No
  // one-charge cap: a transfer does not name a charge.
  const cardReturnEligible =
    !CLIP_REFUNDS_ENABLED &&
    !fintocReturnEligible &&
    !!clipSource &&
    depositToReturn > 0 &&
    Math.round(depositToReturn * 100) <= clipSource.cents;
  const cardActive = cardReturnEligible && !depositReturnToCredit;
  const clientDisplayName = resDetails.company?.name ||
    [resDetails.customer?.first_name, resDetails.customer?.last_name].filter(Boolean).join(" ").replace(/\s+/g, " ");

  // What the client owes comes out of the deposit by re-classifying the deposit
  // money itself (charge_deposit_to_rent): the original row flips — or is split
  // — into a rent payment on the same account and date. It must never insert a
  // new income row: the money arrived once, as the deposit. Returns false (and
  // alerts) on failure so callers stop before marking the deposit settled.
  const chargeDepositToRent = async () => {
    if (depositChargeAmount <= 0) return true;
    const { error } = await supabase.rpc("charge_deposit_to_rent", {
      p_reservation_id: parseInt(reservationId),
      p_amount: depositChargeAmount,
    });
    if (error) {
      alert("No se pudo cobrar la garantía: " + error.message);
      return false;
    }
    return true;
  };

  const confirmReturnDeposit = async () => {
    if (depositReturnSavingRef.current) return;
    depositReturnSavingRef.current = true;
    try {
    const entityType = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;

    // --- Send-to-credit path -------------------------------------------------
    // The pending rent (if any) is charged from the deposit itself, then what
    // is left becomes client credit. Nothing is paid out as cash, and the
    // charged part stays the real deposit money (so it syncs to Alegra with
    // the right bank account when invoiced), not an internal credit payment.
    if (depositReturnToCredit && !depositFullyCharged) {
      if (!entityId) {
        alert("La reservación no tiene un cliente/empresa para acreditar.");
        return;
      }
      const now = new Date().toISOString();
      // 1) Charge the pending rent from the deposit.
      if (!(await chargeDepositToRent())) return;
      // 2) The remainder of the deposit becomes credit.
      const { error: ledErr } = await supabase.from("client_credit_ledger").insert({
        entity_type: entityType,
        entity_id: entityId,
        amount: depositToReturn,
        reason: "deposit",
        source_reservation_id: parseInt(reservationId),
        source_transaction_id: depositTxns[0]?.id ?? null,
        created_by: session?.user?.id,
      });
      if (ledErr) {
        alert("Error: " + ledErr.message);
        return;
      }
      // 3) Mark the deposit settled — nothing was paid out as cash. The money
      // became client credit, so there is no SPEI transfer pending: mark it
      // transferred too, otherwise it lingers in the Pending Transfers queue as
      // a $0 row.
      const { error: resErr } = await supabase
        .from("reservations")
        .update({
          deposit_returned: true,
          deposit_returned_at: now,
          deposit_amount_returned: 0,
          deposit_transferred: true,
          deposit_transferred_at: now,
        })
        .eq("id", reservationId);
      if (resErr) {
        alert("Error: " + resErr.message);
        return;
      }
      await logAudit("deposit_return", {
        deposit: resDetails.deposit,
        existing_charges: existingChargesTotal,
        pending_balance: pendingBalance,
        total_deductions: totalDeductions,
        to_credit: depositToReturn,
      }, `Depósito enviado a crédito del cliente: ${formatPrice(depositToReturn)}`);
      setDepositReturnModal(false);
      refreshData();
      return;
    }
    // --- Cash payout path ----------------------------------------------------
    // Determine the account used to return the deposit. If it's a non-bank
    // account (e.g., cash), auto-mark as transferred since no bank transfer
    // is pending.
    const selectedAcc = depositReturnAccounts.find((a) => a.id === depositReturnAccount);
    // Auto-mark as transferred (no pending SPEI) when the payout account is
    // non-bank, OR when there is nothing to return (deposit fully consumed by
    // deductions) — a $0 return has no transfer to send and must not linger in
    // the Pending Transfers queue.
    const autoTransfer =
      !!(selectedAcc && selectedAcc.type !== "bank") || depositToReturn <= 0;

    if (!(await chargeDepositToRent())) return;

    const now = new Date().toISOString();
    const { error } = await supabase
      .from("reservations")
      .update({
        deposit_returned: true,
        deposit_returned_at: now,
        deposit_amount_returned: depositToReturn,
        ...(autoTransfer ? { deposit_transferred: true, deposit_transferred_at: now } : {}),
      })
      .eq("id", reservationId);

    if (error) {
      alert("Error: " + error.message);
      return;
    }

    await logAudit("deposit_return", {
      deposit: resDetails.deposit,
      existing_charges: existingChargesTotal,
      pending_balance: pendingBalance,
      total_deductions: totalDeductions,
      returned: depositToReturn,
    }, depositFullyCharged
      ? `Garantía cobrada completa: ${formatPrice(depositChargeAmount)}`
      : `Depósito devuelto: ${formatPrice(depositToReturn)}`);

    setDepositReturnModal(false);
    refreshData();
    } finally {
      depositReturnSavingRef.current = false;
    }
  };

  // Quick conciliation: allocate a payment to an invoice
  const openConcilFromPayment = (payment) => {
    const unpaidInvs = issuedInvoices.filter(inv => invoiceDue(inv) > 0.01);
    const firstInv = unpaidInvs[0] || null;
    setConcilModal({ open: true, type: "payment", item: payment, targetId: firstInv ? String(firstInv.id) : null });
    if (firstInv) {
      const maxAmount = Math.min(payment.unallocated_amount ?? payment.amount, invoiceDue(firstInv));
      setConcilAmount(String(Math.round(maxAmount * 100) / 100));
    } else {
      setConcilAmount(String(payment.unallocated_amount ?? payment.amount));
    }
  };

  // Payment detail: full breakdown of one payment — how much is conciliado vs.
  // disponible, and which invoices it's applied to.
  const openPaymentDetail = async (payment) => {
    setPaymentDetail({ open: true, payment, allocations: [], loading: true });
    const { data } = await supabase
      .from("invoice_payment_allocations")
      .select("id, amount, created_at, rep_uuid, invoice:invoice_id(invoice_number, total, status, payment_type)")
      .eq("transaction_id", payment.id)
      .order("created_at", { ascending: true });
    setPaymentDetail((prev) =>
      prev.open && prev.payment?.id === payment.id
        ? { ...prev, allocations: data || [], loading: false }
        : prev
    );
  };

  // A payment can be deleted only inside the same 2h grace window used for
  // inspection reverts, and only while it is still "clean" — untouched by
  // invoicing, conciliación or credit. created_at is the true insert instant
  // (payment_date is the backdatable business date), so comparing absolute Date
  // values here is timezone-safe. delete_payment() re-checks all of this
  // authoritatively; this only decides whether to show the button.
  const isPaymentDeletable = (p) => {
    if (!p?.created_at) return false;
    if (Date.now() - new Date(p.created_at).getTime() > REVERT_WINDOW_MS) return false;
    if (p.invoiced || p.verified_at) return false;
    // Partially applied money would desync silently if the row vanished.
    if (p.type !== "refund" && (p.unallocated_amount ?? p.amount) < p.amount - 0.005)
      return false;
    return true;
  };

  const deletePayment = async () => {
    const p = paymentDetail.payment;
    if (!p) return;
    const kind = p.type === "refund" ? "reembolso" : p.isDeposit ? "depósito" : "pago";
    const ok = window.confirm(
      `¿Eliminar este ${kind} de ${formatPrice(p.amount)}?\n\n` +
        `Esta acción no se puede deshacer.`
    );
    if (!ok) return;

    setPaymentDetail((m) => ({ ...m, deleting: true }));
    const { error } = await supabase.rpc("delete_payment", {
      p_transaction_id: p.id,
    });
    if (error) {
      alert("Error: " + error.message);
      setPaymentDetail((m) => ({ ...m, deleting: false }));
      return;
    }

    await logAudit(
      "payment_deleted",
      { transaction_id: p.id, amount: p.amount, type: p.type, account: p.account?.name },
      `${kind.charAt(0).toUpperCase() + kind.slice(1)} de ${formatPrice(p.amount)} eliminado`
    );

    setPaymentDetail({ open: false, payment: null, allocations: [], loading: false });
    refreshData();
  };

  // Payments that reach this reservation THROUGH one of its invoices rather than
  // by being tagged to it. /payments/new (Banks/CreatePayment.js) writes
  // `reservation: null` on purpose — it is client-scoped, so one company transfer
  // can settle invoices across several reservations. reservations.paid is derived
  // from invoice ALLOCATIONS, so such a payment is counted correctly, but the
  // payment list above filters on transactions.reservation and never showed it —
  // a reservation could read "paid $42,750" while listing only $18,000.
  //
  // Kept in SEPARATE state, never merged into `payments`: that array drives the
  // deposit totals, the unallocated/"Sin facturar" math and the conciliación
  // picker, all of which are reservation-scoped. A client-level payment's
  // remaining credit does NOT belong to this reservation, so folding it in would
  // overstate available money. These rows are display-only.
  const loadIndirectPayments = async () => {
    const invs = await getInvoicesForReservation(reservationId);
    const invoiceIds = (invs || [])
      .filter((i) => i.status !== "void")
      .map((i) => i.id);
    if (!invoiceIds.length) {
      setIndirectPayments([]);
      return;
    }
    const { data } = await supabase
      .from("invoice_payment_allocations")
      .select(
        "id, amount, invoice_id, invoice:invoice_id(invoice_number), transaction:transaction_id(*, account(name))"
      )
      .in("invoice_id", invoiceIds);

    // Only allocations whose payment isn't already listed as a direct one.
    // Group by transaction: one client payment can hit several of this
    // reservation's invoices, and it should appear once with the total it
    // contributed HERE (not its full face value, which may span reservations).
    const byTxn = new Map();
    for (const a of data || []) {
      const t = a.transaction;
      if (!t || String(t.reservation) === String(reservationId)) continue;
      const prev = byTxn.get(t.id);
      if (prev) {
        prev.appliedHere += Number(a.amount) || 0;
        prev.invoiceNumbers.add(a.invoice?.invoice_number || "—");
      } else {
        byTxn.set(t.id, {
          ...t,
          __indirect: true,
          appliedHere: Number(a.amount) || 0,
          invoiceNumbers: new Set([a.invoice?.invoice_number || "—"]),
        });
      }
    }
    setIndirectPayments(
      [...byTxn.values()].sort(
        (a, b) => new Date(b.payment_date || b.created_at) - new Date(a.payment_date || a.created_at)
      )
    );
  };

  const openConcilFromInvoice = (invoice) => {
    const unallocatedPayments = payments.filter(p => !p.isDeposit && (p.unallocated_amount || 0) > 0);
    const firstPay = unallocatedPayments[0] || null;
    setConcilModal({ open: true, type: "invoice", item: invoice, targetId: firstPay ? String(firstPay.id) : null });
    const due = invoiceDue(invoice);
    if (firstPay) {
      const maxAmount = Math.min(due, firstPay.unallocated_amount || 0);
      setConcilAmount(String(Math.round(maxAmount * 100) / 100));
    } else {
      setConcilAmount(String(due));
    }
  };

  const handleConcilTargetChange = (targetId) => {
    setConcilModal(prev => ({ ...prev, targetId }));
    if (concilModal.type === "payment") {
      const inv = issuedInvoices.find(i => String(i.id) === targetId);
      if (inv) {
        const due = invoiceDue(inv);
        const maxAmount = Math.min(concilModal.item.unallocated_amount ?? concilModal.item.amount, due);
        setConcilAmount(String(Math.round(maxAmount * 100) / 100));
      }
    } else {
      const pay = payments.find(p => String(p.id) === targetId);
      if (pay) {
        const due = invoiceDue(concilModal.item);
        const maxAmount = Math.min(due, pay.unallocated_amount || 0);
        setConcilAmount(String(Math.round(maxAmount * 100) / 100));
      }
    }
  };

  // Upper bound for the conciliar amount based on the current modal selection.
  // The DB also rejects over-allocation (trg_prevent_allocation_overflow), but
  // we clamp here so the user can't get an unexpected failure on Apply.
  const concilMaxAmount = (() => {
    if (!concilModal.open || !concilModal.item) return 0;
    let inv, pay;
    if (concilModal.type === "payment") {
      pay = concilModal.item;
      inv = issuedInvoices.find(i => String(i.id) === concilModal.targetId);
    } else {
      inv = concilModal.item;
      pay = payments.find(p => String(p.id) === concilModal.targetId);
    }
    if (!inv || !pay) return 0;
    const due = invoiceDue(inv);
    const unall = pay.unallocated_amount ?? pay.amount ?? 0;
    return Math.max(0, Math.round(Math.min(due, unall) * 100) / 100);
  })();

  const saveConciliation = async () => {
    if (concilSavingRef.current) return;
    concilSavingRef.current = true;
    setConcilSaving(true);
    try {
      const amount = parseFloat(concilAmount) || 0;
      if (amount <= 0) return;

      let payment, invoice;
      if (concilModal.type === "payment") {
        payment = concilModal.item;
        invoice = issuedInvoices.find(inv => String(inv.id) === concilModal.targetId);
        if (!invoice) return;
      } else {
        invoice = concilModal.item;
        payment = payments.find(p => String(p.id) === concilModal.targetId);
        if (!payment) return;
      }

      const due = invoiceDue(invoice);
      const unall = payment.unallocated_amount ?? payment.amount ?? 0;
      const cap = Math.min(due, unall);
      if (amount > cap + 0.01) {
        alert(
          `El monto (${formatPrice(amount)}) excede el máximo permitido: ` +
          `${formatPrice(cap)} (factura debe ${formatPrice(due)}, pago disponible ${formatPrice(unall)}).`
        );
        return;
      }

      // Delegate ledger writes (allocation row, invoice amount_paid/status,
      // transaction unallocated_amount/invoiced) to the shared helper. DB
      // triggers handle reservations.paid/balance/fully_paid; a separate
      // trigger rejects allocations that overflow either side of the ledger.
      try {
        await applyAllocations({
          transactionId: payment.id,
          transactionAmount: payment.amount,
          allocations: [{ invoice, amount }],
          createdBy: session?.user?.id,
        });
      } catch (e) {
        alert("No se pudo conciliar: " + (e?.message || String(e)));
        return;
      }
      // Alegra sync (register payment / stamp complemento de pago for PPD) is
      // now handled inside applyAllocations — single source of truth.

      setConcilModal({ open: false, type: null, item: null });
      setConcilAmount("");
      refreshData();
    } finally {
      setConcilSaving(false);
      concilSavingRef.current = false;
    }
  };

  const addAdditionalDriver = async ({ id }) => {
    const current = resDetails.additional_drivers || [];
    if (current.includes(id)) return;
    const updated = [...current, id];
    const { error } = await supabase
      .from("reservations")
      .update({ additional_drivers: updated })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    setAdditionalDriverModal(false);
    refreshData();
  };

  const removeAdditionalDriver = async (driverId) => {
    const updated = (resDetails.additional_drivers || []).filter(
      (id) => id !== driverId
    );
    const { error } = await supabase
      .from("reservations")
      .update({ additional_drivers: updated })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    refreshData();
  };

  const generateContract = async (templateName) => {
    if (!resDetails.id) return;

    const clean = (resDetails.date_range || "").replace(/[\[\]()]/g, "");
    const parts = clean.split(",");
    const fromStr = parts[0]?.replace(/"/g, "").trim() || "";
    const toStr = parts[1]?.replace(/"/g, "").trim() || "";

    // Fetch inspections + photos for this reservation, then resolve a long-lived
    // signed URL for each signature image so dompdf can fetch it during render.
    const { data: inspectionRows } = await supabase
      .from("reservation_inspections")
      .select(
        "id, type, odometer, fuel_level, notes, signed_at, signed_by_name, signature_image_url, reservation_inspection_photos(file_url, file_name, label)"
      )
      .eq("reservation_id", resDetails.id)
      .order("created_at", { ascending: true });

    // Build three mutually-exclusive flags per inspection type so the template
    // can render each case without nested conditionals. Also resolve signed
    // URLs for each inspection photo so dompdf can embed them.
    const buildInspectionKeys = async (t) => {
      const match = (inspectionRows || []).filter((i) => i.type === t).pop();
      if (!match) return { signed: null, pending: null, missing: true, photos: [] };

      const photos = await Promise.all(
        (match.reservation_inspection_photos || []).map(async (p) => {
          const { data: signed } = await supabase.storage
            .from("inspection-photos")
            .createSignedUrl(p.file_url, 60 * 60); // 1 hour, only needed during render
          return {
            url: signed?.signedUrl || "",
            label: (p.label || "").replace(/_/g, " "),
          };
        })
      );

      const data = {
        odometer: match.odometer,
        fuel_level: match.fuel_level,
        notes: match.notes || "",
      };
      if (match.signature_image_url) {
        const { data: sig } = await supabase.storage
          .from("inspection-signatures")
          .createSignedUrl(match.signature_image_url, 60 * 60 * 24 * 365); // 1 year
        return {
          signed: {
            ...data,
            signed_at: match.signed_at,
            signed_by_name: match.signed_by_name || "",
            signature_image_url: sig?.signedUrl || "",
          },
          pending: null,
          missing: null,
          photos,
        };
      }
      return { signed: null, pending: data, missing: null, photos };
    };
    const co = await buildInspectionKeys("checkout");
    const re = await buildInspectionKeys("checkin");

    // Mint signed gallery URL via the API (HMAC-protected; secret stays server-side)
    let galleryUrl = "";
    try {
      const r = await fetch(
        `https://api.gomoverent.com/v2/gallery_link.php?reservation_id=${resDetails.id}`,
        { headers: { Authorization: "Bearer Zgii9qpMB4fXrHGK8dz6BrU0IDoz6NOb" } }
      );
      const j = await r.json();
      galleryUrl = j?.data?.url || j?.url || "";
    } catch (_) {}


    const vars = {
      reservation_id: resDetails.id,
      customer: {
        first_name: resDetails.customer?.first_name || "",
        last_name: resDetails.customer?.last_name || "",
        phone: resDetails.customer?.phone || "",
        email: resDetails.customer?.email || "",
        license_number: resDetails.customer?.license_number || "",
        license_state: resDetails.customer?.license_state || "",
        id_type: resDetails.customer?.id_type || "INE",
        id_number: resDetails.customer?.id_number || "",
      },
      company: resDetails.company ? {
        name: resDetails.company.name || "",
        rfc: resDetails.company.rfc || "",
        address: resDetails.company.address || "",
        contact_name: resDetails.company.contact_name || "",
        contact_phone: resDetails.company.contact_phone || "",
      } : null,
      has_company: !!resDetails.company,
      car: {
        plate: resDetails.car?.plate || "",
        brand: resDetails.car?.model?.brand?.name || "",
        model: resDetails.car?.model?.show_as || resDetails.car?.model?.name || "",
        color: resDetails.car?.color || "",
        vin: resDetails.car?.vin || "",
        odometer: resDetails.car?.odometer || 0,
      },
      insurance_label: insuranceLabels[resDetails.insurance] || resDetails.insurance,
      insurance_text: insuranceTexts[resDetails.insurance] || "",
      delivery_address: resDetails.delivery?.address || "Oficina Central - Colón",
      delivery_fee: resDetails.delivery?.fee || 0,
      return_address: resDetails.return?.address || "Oficina Central - Colón",
      return_fee: resDetails.return?.fee || 0,
      delivery_fuel: co.signed?.fuel_level || co.pending?.fuel_level || "______",
      from_date: fromStr.substring(0, 10),
      from_time: fromStr.substring(11, 16),
      to_date: toStr && toStr !== "infinity" ? toStr.substring(0, 10) : "Indefinido",
      to_time: toStr && toStr !== "infinity" ? toStr.substring(11, 16) : "",
      rent_days: resDetails.rent_time?.days || 0,
      daily_rate: resDetails.totals?.dailyPrice || 0,
      total_rent: resDetails.totals?.totalRent || 0,
      total_price: resDetails.total_price || 0,
      deposit: resDetails.deposit || 0,
      today: new Date().toISOString().substring(0, 10),
      checkout_signed: co.signed,
      checkout_pending: co.pending,
      checkout_missing: co.missing,
      checkout_photos: co.photos,
      return_signed: re.signed,
      return_pending: re.pending,
      return_missing: re.missing,
      return_photos: re.photos,
      full_gallery_url: galleryUrl,
    };

    try {
      const response = await fetch("https://api.gomoverent.com/v2/pdf/generate.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer Zgii9qpMB4fXrHGK8dz6BrU0IDoz6NOb",
        },
        body: JSON.stringify({
          template: templateName,
          vars,
          output: "supabase",
        }),
      });

      const raw = await response.text();
      let result;
      try {
        result = JSON.parse(raw);
      } catch (_) {
        // PHP warnings (notices/deprecations) can leak before the JSON body.
        // Try to salvage: parse the last JSON object in the response.
        const match = raw.match(/\{[\s\S]*\}\s*$/);
        if (match) {
          try { result = JSON.parse(match[0]); } catch (_) {}
        }
        if (!result) {
          console.error("PDF engine returned non-JSON:", raw);
          alert(
            `HTTP ${response.status} del API PDF. Respuesta:\n\n` +
              raw.slice(0, 500)
          );
          return;
        }
      }

      if (result.success && result.result?.url) {
        window.open(result.result.url, "_blank");
      } else if (result.success && result.data?.url) {
        window.open(result.data.url, "_blank");
      } else {
        alert("Error generando documento: " + (result.error || "Unknown error"));
      }
    } catch (err) {
      alert("Error de conexión: " + err.message);
    }
  };

  const saveDateEdit = async () => {
    if (pricePeriodsError) {
      alert("Los periodos de tarifa no se pudieron cargar, por lo que la sección vigente podría estar desactualizada. Recarga la página antes de modificar la tarifa.");
      return;
    }
    const clean = resDetails.date_range.replace(/[\[\]()]/g, "");
    const parts = clean.split(",");
    const startStr = parts[0]?.replace(/"/g, "").trim();
    const endStr = parts[1]?.replace(/"/g, "").trim();

    let newStart = startStr;
    let newEnd = endStr;
    if (dateEditModal.type === "entrega") {
      newStart = `${dateEditModal.date} ${dateEditModal.hour}:00+00`;
    } else {
      newEnd = `${dateEditModal.date} ${dateEditModal.hour}:00+00`;
    }

    const hasEnd = newEnd && newEnd !== "" && newEnd !== "infinity";
    const newDateRange = hasEnd ? `[${newStart},${newEnd}]` : `[${newStart},)`;
    const fromDate = newStart.substring(0, 10);
    const fromHour = newStart.substring(11, 16);
    const toDate = hasEnd ? newEnd.substring(0, 10) : "";
    const toHour = hasEnd ? newEnd.substring(11, 16) : "";

    let time = hasEnd ? getReservationTime(fromDate, fromHour, toDate, toHour) : (resDetails.rent_time || { days: 30, hours: 0 });

    const canRecalc =
      dateEditModal.recalc && !resDetails.is_sublease && resDetails.car?.model?.id;

    let details;
    if (canRecalc) {
      details = await calculateReservationTotal(
        time,
        resDetails.car.model.id,
        "card",
        resDetails.insurance,
        "local"
      );
      if (details.error) {
        alert("Error recalculando precio: " + details.error);
        return;
      }
    } else {
      // Preserve daily price; recompute totalRent with the standard hours rule
      const dailyPrice = resDetails.totals?.dailyPrice || 0;
      const deposit = resDetails.totals?.deposit || 0;
      let { days, hours } = time;
      let hoursMultiplier = 0;
      if (hours <= 2) hoursMultiplier = 0;
      else if (hours <= 5) hoursMultiplier = 0.3;
      else {
        days += 1;
        hours = 0;
      }
      if (days === 0) days = 1;
      const hoursExtra = dailyPrice * hoursMultiplier;
      const totalRent = dailyPrice * days + hoursExtra;
      time = { days, hours };
      details = { dailyPrice, deposit, hoursExtra, totalRent, time };
    }

    const deliveryFee = resDetails.delivery?.fee || 0;
    const returnFee = resDetails.return?.fee || 0;
    const totalPrice = details.totalRent + deliveryFee + returnFee;

    // Before updating date_range: clear billable_amount on the open section
    // (so the trigger recomputes from days × daily_price), and when we just
    // re-quoted, propagate the new daily_price to the section too — otherwise
    // the trigger would compute against the old rate and overwrite our totals.
    const openSection = pricePeriods.find((p) => p.effective_to == null);
    const { error: errClear } = await clearOpenSectionBillableAmount(reservationId);
    if (errClear) {
      alert("Error: " + errClear.message);
      return;
    }
    if (
      openSection &&
      canRecalc &&
      details.dailyPrice !== openSection.daily_price
    ) {
      const { error: errPrice } = await supabase
        .from("reservation_price_periods")
        .update({ daily_price: details.dailyPrice })
        .eq("id", openSection.id);
      if (errPrice) {
        alert("Error: " + errPrice.message);
        return;
      }
    }

    const { error } = await supabase
      .from("reservations")
      .update({
        date_range: newDateRange,
        rent_time: time,
        totals: details,
        total_price: totalPrice,
      })
      .eq("id", reservationId);

    if (error) {
      alert("Error: " + error.message);
      return;
    }
    setDateEditModal({ ...dateEditModal, open: false });
    refreshData();
  };

  const extendReservation = async () => {
    if (!extendDate) return;
    setExtendError("");
    if (pricePeriodsError) {
      setExtendError("Los periodos de tarifa no se pudieron cargar, por lo que la sección vigente podría estar desactualizada. Recarga la página antes de modificar la tarifa.");
      return;
    }
    const clean = resDetails.date_range.replace(/[\[\]()]/g, "");
    const startStr = clean.split(",")[0]?.replace(/"/g, "").trim();
    const newDateRange = `[${startStr},${extendDate} ${extendHour}]`;

    const fromDate = startStr.substring(0, 10);
    const fromHour = startStr.substring(11, 16);
    const time = getReservationTime(fromDate, fromHour, extendDate, extendHour);

    // Validate "new rate from date" inputs if active.
    if (extendApplyNewRate) {
      const newPrice = parseFloat(extendNewRatePrice);
      if (!extendNewRateDate || !Number.isFinite(newPrice) || newPrice < 0) {
        setExtendError("Falta fecha o tarifa válida para la nueva sección.");
        return;
      }
      if (extendNewRateDate < fromDate || extendNewRateDate > extendDate) {
        setExtendError("La fecha de la nueva tarifa debe caer dentro del rango de la renta.");
        return;
      }
    }

    // 1) Clear billable_amount on the open section so the date-range trigger's
    //    compute_reservation_total_rent recomputes from days × daily_price
    //    instead of returning the stale frozen value.
    const { error: errClear } = await clearOpenSectionBillableAmount(reservationId);
    if (errClear) {
      setExtendError("Error: " + errClear.message);
      return;
    }

    // 2) Extend date_range. The sync trigger fires and rebuilds totals from
    //    sections; the current open section naturally extends since
    //    effective_to is NULL.
    const { error: errExtend } = await supabase
      .from("reservations")
      .update({ date_range: newDateRange, rent_time: time })
      .eq("id", reservationId);
    if (errExtend) {
      setExtendError("Error: " + errExtend.message);
      return;
    }

    // 3) Optionally open a new rate section from the transition date.
    if (extendApplyNewRate) {
      const newPrice = parseFloat(extendNewRatePrice);
      const transition = extendNewRateDate;
      const openSection = pricePeriods.find((p) => p.effective_to == null);
      try {
        if (openSection) {
          const closedTo = addDaysISO(transition, -1);
          if (closedTo < openSection.effective_from) {
            setExtendError("La fecha de la nueva tarifa no puede ser anterior al inicio de la sección actual.");
            return;
          }
          const { error: errClose } = await supabase
            .from("reservation_price_periods")
            .update({ effective_to: closedTo })
            .eq("id", openSection.id);
          if (errClose) throw errClose;
        }
        const { error: errInsert } = await supabase
          .from("reservation_price_periods")
          .insert({
            reservation_id: reservationId,
            daily_price: newPrice,
            effective_from: transition,
            effective_to: null,
            reason: "Extensión con nueva tarifa",
            created_by: session?.user?.id || null,
          });
        if (errInsert) throw errInsert;
      } catch (e) {
        setExtendError(e.message || "Error al crear la nueva sección.");
        return;
      }

      // Section restructuring happens after the date_range trigger already
      // fired with only the pre-existing section, so totals are stale until we
      // re-sync against the new sections.
      const { error: errSync } = await resyncReservationTotals(reservationId);
      if (errSync) {
        setExtendError("Error: " + errSync.message);
        return;
      }
    }

    setExtendModal(false);
    setExtendApplyNewRate(false);
    setExtendNewRateDate("");
    setExtendNewRatePrice("");
    setExtendError("");
    refreshData();
  };

  // ---------- Cambiar tarifa diaria desde [fecha] ----------
  //
  // Closes the current open section at transition-1 and inserts a new open
  // section at transition with the new rate. The DB sync trigger recomputes
  // total_price; the retro-change guard blocks if any stamped invoice's
  // period overlaps the new section's range.
  // Earliest date a new section can start at: the day after the latest stamped
  // (non-void) invoice's period_to for this reservation. Beyond that point, a
  // new rate doesn't re-rate any already-billed day, so the DB guard allows it.
  const computeMinChangeDate = () => {
    const openSection = pricePeriods.find((p) => p.effective_to == null);
    const sectionStart = openSection?.effective_from || null;
    let latestStampedEnd = null;
    for (const inv of issuedInvoices) {
      if (!inv.stamped || inv.status === "void" || !inv.period_to) continue;
      if (!latestStampedEnd || inv.period_to > latestStampedEnd) {
        latestStampedEnd = inv.period_to;
      }
    }
    const afterStamped = latestStampedEnd ? addDaysISO(latestStampedEnd, 1) : null;
    if (sectionStart && afterStamped) {
      return sectionStart > afterStamped ? sectionStart : afterStamped;
    }
    return sectionStart || afterStamped || null;
  };

  // Parse the reservation's `tstzrange` date_range into {start, end} date-only
  // strings (YYYY-MM-DD). The DB serializes it like
  // `["2026-05-19 18:00:00+00","2026-05-21 18:00:00+00"]`.
  const getReservationDateBounds = () => {
    const raw = resDetails?.date_range || "";
    const clean = raw.replace(/[\[\]()"]/g, "");
    const [s, e] = clean.split(",").map((p) => (p || "").trim());
    return {
      start: s ? s.substring(0, 10) : null,
      end: e ? e.substring(0, 10) : null,
    };
  };

  // Clamp YYYY-MM-DD `d` into [min, max] (either bound may be null).
  const clampISODate = (d, min, max) => {
    if (!d) return d;
    if (min && d < min) return min;
    if (max && d > max) return max;
    return d;
  };

  const openChangeRateModal = () => {
    const today = new Date().toISOString().substring(0, 10);
    const minStamped = computeMinChangeDate();
    const { start: resStart, end: resEnd } = getReservationDateBounds();
    const minDate = [minStamped, resStart].filter(Boolean).sort().pop() || null;
    const defaultDate = clampISODate(today, minDate, resEnd);
    setChangeRateForm({
      date: defaultDate,
      price: String(resDetails.totals?.dailyPrice || ""),
      reason: "",
      wholeReservation: true,
    });
    setChangeRateError("");
    setChangeRateModal(true);
  };

  const saveChangeRate = async () => {
    const { date, price, reason, wholeReservation } = changeRateForm;
    setChangeRateError("");
    if (pricePeriodsError) {
      setChangeRateError("Los periodos de tarifa no se pudieron cargar, por lo que la sección vigente podría estar desactualizada. Recarga la página antes de modificar la tarifa.");
      return;
    }
    const newPrice = parseFloat(price);
    if (!Number.isFinite(newPrice) || newPrice < 0) {
      setChangeRateError("Tarifa inválida.");
      return;
    }

    if (wholeReservation) {
      // Replace every existing price period with one row covering the full
      // reservation. Stamped invoices block this because re-rating an already
      // billed day conflicts with the DB's retro-change guard.
      const { start: resStart } = getReservationDateBounds();
      if (!resStart) {
        setChangeRateError("No se pudo determinar la fecha de inicio de la reservación.");
        return;
      }
      const latestStamped = issuedInvoices
        .filter((i) => i.stamped && i.status !== "void" && i.period_to)
        .reduce((acc, i) => (!acc || i.period_to > acc ? i.period_to : acc), null);
      if (latestStamped) {
        setChangeRateError(
          `Esta reservación tiene facturas timbradas hasta el ${latestStamped}. No es posible aplicar la tarifa a toda la reservación; desmarca la opción y selecciona una fecha posterior, o emite una nota de crédito primero.`
        );
        return;
      }
      setChangeRateSaving(true);
      try {
        const { error: errDel } = await supabase
          .from("reservation_price_periods")
          .delete()
          .eq("reservation_id", reservationId);
        if (errDel) throw errDel;
        const { error: insErr } = await supabase
          .from("reservation_price_periods")
          .insert({
            reservation_id: reservationId,
            daily_price: newPrice,
            effective_from: resStart,
            effective_to: null,
            reason: reason || null,
            created_by: session?.user?.id || null,
          });
        if (insErr) throw insErr;
        const { error: errSync } = await resyncReservationTotals(reservationId);
        if (errSync) throw errSync;
        setChangeRateModal(false);
        refreshData();
      } catch (e) {
        setChangeRateError(e.message || "Error al guardar.");
      } finally {
        setChangeRateSaving(false);
      }
      return;
    }

    if (!date) {
      setChangeRateError("Selecciona una fecha.");
      return;
    }
    const { start: resStart, end: resEnd } = getReservationDateBounds();
    if (resStart && date < resStart) {
      setChangeRateError(`La fecha debe estar dentro de la reservación (${resStart} – ${resEnd}).`);
      return;
    }
    if (resEnd && date > resEnd) {
      setChangeRateError(`La fecha debe estar dentro de la reservación (${resStart} – ${resEnd}).`);
      return;
    }
    const openSection = pricePeriods.find((p) => p.effective_to == null);
    if (!openSection) {
      setChangeRateError("No hay sección de tarifa abierta.");
      return;
    }
    if (date < openSection.effective_from) {
      setChangeRateError("La fecha debe ser igual o posterior al inicio de la sección actual (" + openSection.effective_from + ").");
      return;
    }
    const minDate = computeMinChangeDate();
    if (minDate && date < minDate) {
      const latestStamped = issuedInvoices
        .filter((i) => i.stamped && i.status !== "void" && i.period_to)
        .reduce((acc, i) => (!acc || i.period_to > acc ? i.period_to : acc), null);
      setChangeRateError(
        `La nueva tarifa sólo puede iniciar desde ${minDate} en adelante. La factura más reciente cubre hasta ${latestStamped}.`
      );
      return;
    }
    setChangeRateSaving(true);
    try {
      // Clear the open section's billable_amount before closing it. Otherwise
      // the now-closed section retains the stale initial-creation total and
      // compute_reservation_total_rent uses that flat value instead of
      // days × daily_price for the closed range.
      const { error: errClear } = await clearOpenSectionBillableAmount(reservationId);
      if (errClear) throw errClear;

      const closedTo = addDaysISO(date, -1);
      if (closedTo >= openSection.effective_from) {
        const { error } = await supabase
          .from("reservation_price_periods")
          .update({ effective_to: closedTo })
          .eq("id", openSection.id);
        if (error) throw error;
      } else {
        // date === effective_from: replace the section entirely (zero-day old section)
        const { error } = await supabase
          .from("reservation_price_periods")
          .delete()
          .eq("id", openSection.id);
        if (error) throw error;
      }
      const { error: insErr } = await supabase
        .from("reservation_price_periods")
        .insert({
          reservation_id: reservationId,
          daily_price: newPrice,
          effective_from: date,
          effective_to: null,
          reason: reason || null,
          created_by: session?.user?.id || null,
        });
      if (insErr) throw insErr;

      // No date_range UPDATE happened, so the sync trigger didn't fire — call
      // it explicitly so reservations.total_price reflects the new sections.
      const { error: errSync } = await resyncReservationTotals(reservationId);
      if (errSync) throw errSync;

      setChangeRateModal(false);
      refreshData();
    } catch (e) {
      setChangeRateError(e.message || "Error al guardar.");
    } finally {
      setChangeRateSaving(false);
    }
  };

  // Date helpers: add N days to an ISO YYYY-MM-DD string.
  function addDaysISO(iso, n) {
    const d = new Date(iso + "T00:00:00Z");
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().substring(0, 10);
  }

  const handleSecondaryActions = (e) => {
    const actionId = e;
    if (actionId === "add_deposit") {
      setPaymentsWindow({ active: true, isDeposit: true });
    }
    if (actionId === "add_payment") {
      setPaymentsWindow({ active: true, isDeposit: false });
    }
    if (actionId === "cancel") {
      setCancelModal(true);
    }
  };

  const openRefundModal = async () => {
    const overpayment = Math.abs(Math.min(0, (resDetails.total_price || 0) - (resDetails.paid || 0)));
    setRefundAmount(String(overpayment));

    // Load available accounts (same source as the deposit-return modal). Bank
    // accounts are collapsed into a single "Transferencia SPEI" option in the
    // Select below; a SPEI refund stays pending in the transfers queue.
    const { data: accs } = await supabase
      .from("transaction_accounts")
      .select("id, name, type")
      .order("order", { ascending: true });
    setRefundAccounts(accs || []);

    // Default to the account the money originally came in on if it's a bank
    // (→ SPEI), otherwise the first bank, otherwise the first account.
    const { data: srcTx } = await supabase
      .from("transactions")
      .select("account")
      .eq("reservation", reservationId)
      .eq("type", "income")
      .eq("isDeposit", false)
      .not("account", "is", null)
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    const firstBank = (accs || []).find((a) => a.type === "bank");
    const srcAcc = (accs || []).find((a) => a.id === srcTx?.account);
    const defaultId =
      (srcAcc && srcAcc.type === "bank" ? srcAcc.id : null) ??
      firstBank?.id ??
      accs?.[0]?.id ??
      null;
    setRefundAccount(defaultId != null ? String(defaultId) : "");

    setRefundModal(true);
  };

  const openCreditModal = () => {
    const overpayment = Math.abs(Math.min(0, (resDetails.total_price || 0) - (resDetails.paid || 0)));
    setCreditAmount(String(overpayment));
    setCreditModal(true);
  };

  // Open balance across this reservation's non-void issued invoices.
  const reservationOpenInvoiceBalance = issuedInvoices
    .filter((i) => i.status !== "void")
    .reduce((sum, i) => sum + Math.max(0, invoiceDue(i)), 0);

  const openApplyCreditModal = () => {
    const owed = Math.max(0, (resDetails.total_price || 0) - (resDetails.paid || 0));
    const suggested = Math.min(externalCredit, owed > 0 ? owed : externalCredit);
    setApplyCreditAmount(String(Math.round(suggested * 100) / 100));
    setApplyCreditModal(true);
  };

  // Bring credit down from the client's profile to this reservation (it lands as
  // an unapplied payment on an internal account; conciliate it to an invoice).
  const saveApplyCredit = async () => {
    const amount = parseFloat(applyCreditAmount) || 0;
    if (amount <= 0) return;
    setApplyCreditSaving(true);
    const entityType = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;
    const result = await bringCreditToReservation({
      entityType,
      entityId,
      reservationId: parseInt(reservationId),
      amount,
      createdBy: session?.user?.id,
    });
    if (!result.success) {
      alert("Error: " + result.error);
      setApplyCreditSaving(false);
      return;
    }
    await logAudit(
      "credit_apply",
      { amount },
      `Crédito traído del perfil a la reservación: ${formatPrice(amount)}`
    );
    setApplyCreditModal(false);
    setApplyCreditAmount("");
    setApplyCreditSaving(false);
    refreshData();
  };

  // Pay this reservation's deposit from the client's profile credit. Records a
  // deposit transaction on the internal credit account (collateral, excluded
  // from `paid`) and draws down the ledger — no new cash enters the bank.
  const openDepositCreditModal = () => {
    const depositPaid = payments
      .filter((p) => p.isDeposit)
      .reduce((sum, p) => sum + (p.amount || 0), 0);
    const missing = Math.max(0, (resDetails.deposit || 0) - depositPaid);
    const suggested = Math.min(externalCredit, missing > 0 ? missing : externalCredit);
    setDepositCreditAmount(String(Math.round(suggested * 100) / 100));
    setDepositCreditModal(true);
  };

  const saveDepositCredit = async () => {
    const amount = parseFloat(depositCreditAmount) || 0;
    if (amount <= 0) return;
    setDepositCreditSaving(true);
    const entityType = resDetails.company ? "company" : "customer";
    const entityId = resDetails.company?.id || resDetails.customer?.id;
    const result = await bringCreditToReservation({
      entityType,
      entityId,
      reservationId: parseInt(reservationId),
      amount,
      createdBy: session?.user?.id,
      isDeposit: true,
    });
    if (!result.success) {
      alert("Error: " + result.error);
      setDepositCreditSaving(false);
      return;
    }
    await logAudit(
      "deposit_credit",
      { amount },
      `Depósito cobrado con crédito del cliente: ${formatPrice(amount)}`
    );
    setDepositCreditModal(false);
    setDepositCreditAmount("");
    setDepositCreditSaving(false);
    refreshData();
  };

  const saveMoveToCredit = async () => {
    const amount = parseFloat(creditAmount) || 0;
    if (amount <= 0) return;
    setCreditSaving(true);
    const result = await moveOverpaymentToCredit({
      entityType: resDetails.company ? "company" : "customer",
      entityId: resDetails.company?.id || resDetails.customer?.id,
      reservationId: parseInt(reservationId),
      amount,
      createdBy: session?.user?.id,
    });
    if (!result.success) {
      alert("Error: " + result.error);
      setCreditSaving(false);
      return;
    }
    await logAudit(
      "credit_move",
      { amount },
      `Excedente movido a crédito del cliente: ${formatPrice(amount)}`
    );
    setCreditModal(false);
    setCreditAmount("");
    setCreditSaving(false);
    refreshData();
  };

  const saveRefund = async () => {
    if (refundSavingRef.current) return;
    refundSavingRef.current = true;
    const amount = parseFloat(refundAmount) || 0;
    if (amount <= 0) { refundSavingRef.current = false; return; }
    setRefundSaving(true);

    const billingEntityType = resDetails.company ? "company" : "customer";
    const billingEntityId = resDetails.company?.id || resDetails.customer?.id;

    // Non-bank methods (cash, card) settle immediately. A bank method means a
    // SPEI transfer that still has to be sent, so it stays pending in the
    // transfers queue (transferred=false). Mirrors the deposit-return flow.
    const selectedAcc = refundAccounts.find(
      (a) => String(a.id) === refundAccount
    );
    const transferred = !selectedAcc || selectedAcc.type !== "bank";
    const now = new Date().toISOString();

    const { error } = await supabase.from("transactions").insert({
      type: "refund",
      amount,
      reservation: parseInt(reservationId),
      customer: resDetails.customer?.id || null,
      isDeposit: false,
      account: refundAccount ? parseInt(refundAccount) : null,
      unallocated_amount: 0,
      billing_entity_type: billingEntityType,
      billing_entity_id: billingEntityId,
      invoiced: true,
      payment_date: now.substring(0, 10),
      transferred,
      transferred_at: transferred ? now : null,
      created_by: session?.user?.id,
    });

    if (error) {
      alert("Error: " + error.message);
      setRefundSaving(false);
      refundSavingRef.current = false;
      return;
    }

    // reservations.paid / balance / fully_paid are recomputed by the
    // trg_txn_recompute trigger off the refund transaction insert above.
    //
    // Do NOT reduce unallocated_amount on the source income transactions here.
    // A refund is a separate 'refund' row, not an allocation, so it must keep
    // the invariant unallocated_amount = amount - Σ(allocations). The refund is
    // accounted for once, by recompute_reservation_payments subtracting refunds
    // when computing `paid` (and getBlockers nets refunds out of unallocated the
    // same way). Reducing unallocated_amount here double-counted the refund and
    // understated `paid` by the refund amount.

    await logAudit("refund", { amount }, `Reembolso de ${formatPrice(amount)}`);

    setRefundModal(false);
    setRefundAmount("");
    setRefundAccount("");
    setRefundSaving(false);
    refundSavingRef.current = false;
    refreshData();
  };

  // Current daily rate — used to price a whole-day discount at creation and
  // FREEZE it, so a later rate change never alters the discount's value.
  const currentDailyRate = resDetails?.totals?.dailyPrice || 0;

  const saveDiscount = async () => {
    // A discount is either N whole days (priced at the frozen current rate) or a
    // raw peso amount. Whole-day discounts store `days` + `daily_price` so the
    // invoice UI can drop clean days; both store the frozen `amount` that
    // sync_reservation_totals subtracts from total_price.
    const isDays = discountMode === "dias";
    const days = isDays ? parseInt(discountDays, 10) || 0 : null;
    const amount = isDays
      ? Math.round(days * currentDailyRate * 100) / 100
      : parseFloat(discountAmount) || 0;
    if (amount <= 0 || (isDays && days <= 0)) return;

    const { error } = await supabase.from("reservation_discounts").insert({
      reservation_id: reservationId,
      amount,
      days: isDays ? days : null,
      daily_price: isDays ? currentDailyRate : null,
      reason: discountReason || null,
      created_by: session?.user?.id,
    });
    if (error) { alert("Error: " + error.message); return; }

    // DB trigger reservation_discounts_sync recomputes total_price / balance /
    // fully_paid via sync_reservation_totals — no manual adjustment here.

    const label = isDays
      ? `Descuento de ${days} día${days === 1 ? "" : "s"} (${formatPrice(amount)})`
      : `Descuento de ${formatPrice(amount)}`;
    await logAudit("discount", { amount, days, reason: discountReason }, `${label}${discountReason ? `: ${discountReason}` : ""}`);

    setDiscountModal(false);
    setDiscountDays("");
    setDiscountAmount("");
    setDiscountReason("");
    refreshData();
  };

  const deleteDiscount = async (discountId) => {
    const disc = discounts.find(d => d.id === discountId);
    if (!disc) return;
    await supabase.from("reservation_discounts").delete().eq("id", discountId);

    // DB trigger reservation_discounts_sync handles total_price / balance /
    // fully_paid via sync_reservation_totals.

    await logAudit("discount_removed", { amount: disc.amount }, `Descuento eliminado: ${formatPrice(disc.amount)}`);
    refreshData();
  };

  const cancelReservation = async () => {
    if (!cancelReason.trim()) {
      alert("Ingresa un motivo de cancelación");
      return;
    }
    // Defensive: the unit is already out — block here too (DB trigger also enforces).
    if (resDetails.checked_out) {
      alert("No se puede cancelar una reservación que ya tiene salida (checkout).");
      setCancelModal(false);
      return;
    }
    const { error } = await supabase
      .from("reservations")
      .update({ status: "cancelled", cancel_reason: cancelReason.trim() })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    await logAudit("status_change", { from: resDetails.status, to: "cancelled" }, cancelReason.trim());
    setCancelModal(false);
    setCancelReason("");
    refreshData();
  };

  const reactivateReservation = async () => {
    const { error } = await supabase
      .from("reservations")
      .update({ status: "active", cancel_reason: null })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    await logAudit("status_change", { from: "cancelled", to: "active" }, "Reactivada");
    refreshData();
  };

  const markNoShow = async () => {
    const { error } = await supabase
      .from("reservations")
      .update({ status: "no_show" })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    await logAudit("status_change", { from: resDetails.status, to: "no_show" }, "No-Show");
    refreshData();
  };

  // Latest inspection of a given type that can still be reverted, or null.
  // Revertible = carries a revert snapshot (created after the feature shipped)
  // AND was recorded within the last 2 hours (grace window; the RPC enforces
  // the same limit authoritatively). recorded_at is a true now() instant, so
  // comparing absolute Date values here is timezone-safe.
  const revertibleInspection = (t) =>
    [...inspections]
      .filter(
        (i) =>
          i.type === t &&
          i.revert_snapshot &&
          i.recorded_at &&
          Date.now() - new Date(i.recorded_at).getTime() <= REVERT_WINDOW_MS
      )
      .sort((a, b) => new Date(b.recorded_at) - new Date(a.recorded_at))[0] || null;

  const revertInspection = async () => {
    const inspectionId = revertModal.inspectionId;
    if (!inspectionId) return;
    setRevertModal((m) => ({ ...m, busy: true }));

    const { data, error } = await supabase.rpc("revert_inspection", {
      p_inspection_id: inspectionId,
    });
    if (error) {
      alert("Error: " + error.message);
      setRevertModal((m) => ({ ...m, busy: false }));
      return;
    }

    // RPC already deleted the DB rows; now clean up the storage objects it
    // reported back so no orphaned photos/signatures remain.
    const photos = data?.photos || [];
    const signatures = data?.signatures || [];
    if (photos.length > 0) {
      await supabase.storage.from("inspection-photos").remove(photos);
    }
    if (signatures.length > 0) {
      await supabase.storage.from("inspection-signatures").remove(signatures);
    }

    await logAudit(
      "inspection_reverted",
      { type: revertModal.type, inspection_id: inspectionId },
      revertModal.type === "checkout" ? "Entrega cancelada" : "Devolución cancelada"
    );

    setRevertModal({ open: false, type: null, inspectionId: null, busy: false });
    refreshData();
  };

  const changeCustomer = async ({ id }) => {
    const { error } = await supabase
      .from("reservations")
      .update({ customer: id })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    refreshData();
  };

  const [carChangeStep, setCarChangeStep] = useState(null);
  const [carChangeReason, setCarChangeReason] = useState("");
  const [carChangeDate, setCarChangeDate] = useState(moment().format("YYYY-MM-DD"));

  const [subleaseChangeModal, setSubleaseChangeModal] = useState(false);
  const [subleaseChangeData, setSubleaseChangeData] = useState({
    model_id: "",
    plate: "",
    vin: "",
    reason: "",
    date: moment().format("YYYY-MM-DD"),
  });
  const [carModelsList, setCarModelsList] = useState([]);

  useEffect(() => {
    const loadModels = async () => {
      const { data } = await supabase
        .from("car_models")
        .select("id, name, show_as, brand:car_brands(name)")
        .order("name");
      setCarModelsList(data || []);
    };
    loadModels();
  }, []);

  const openSubleaseChange = () => {
    setSubleaseChangeData({
      model_id: resDetails.is_sublease ? String(resDetails.sublease_model_id || "") : "",
      plate: resDetails.is_sublease ? resDetails.sublease_plate || "" : "",
      vin: resDetails.is_sublease ? resDetails.sublease_vin || "" : "",
      reason: "",
      date: moment().format("YYYY-MM-DD"),
    });
    setSubleaseChangeModal(true);
  };

  const confirmSubleaseChange = async () => {
    if (!subleaseChangeData.model_id || !subleaseChangeData.plate.trim() || !subleaseChangeData.reason.trim()) {
      alert("Completa modelo, placa y motivo.");
      return;
    }
    const previousCarId = resDetails.car?.id || null;
    const wasSublease = !!resDetails.is_sublease;
    const changeTimestamp = `${subleaseChangeData.date} 00:00:00+00`;

    await supabase.from("reservation_car_changes").insert({
      reservation_id: reservationId,
      previous_car_id: previousCarId,
      new_car_id: null,
      // Los reportes de utilización reconstruyen la línea de tiempo de unidades
      // desde estas columnas (ver reservation_unit_segments), no desde `reason`.
      previous_sublease_plate: wasSublease ? normPlate(resDetails.sublease_plate) : null,
      new_sublease_plate: normPlate(subleaseChangeData.plate),
      reason: `[Subarrendado ${subleaseChangeData.plate}]${subleaseChangeData.reason ? " " + subleaseChangeData.reason : ""}`,
      daily_price_changed: false,
      previous_daily_price: resDetails.totals?.dailyPrice || 0,
      new_daily_price: resDetails.totals?.dailyPrice || 0,
      changed_by: session?.user?.id,
      changed_at: changeTimestamp,
    });

    const { error } = await supabase
      .from("reservations")
      .update({
        car: null,
        is_sublease: true,
        sublease_model_id: parseInt(subleaseChangeData.model_id),
        sublease_plate: subleaseChangeData.plate.trim().toUpperCase(),
        sublease_vin: subleaseChangeData.vin.trim().toUpperCase() || null,
      })
      .eq("id", reservationId);

    if (error) {
      alert("Error: " + error.message);
      return;
    }

    await logAudit(
      wasSublease ? "sublease_update" : "car_change",
      {
        previous_car: previousCarId,
        sublease: {
          model_id: parseInt(subleaseChangeData.model_id),
          plate: subleaseChangeData.plate,
          vin: subleaseChangeData.vin || null,
        },
        reason: subleaseChangeData.reason,
        date: subleaseChangeData.date,
      },
      wasSublease
        ? `Subarrendado actualizado a ${subleaseChangeData.plate} (${subleaseChangeData.date})`
        : `Cambio a subarrendado ${subleaseChangeData.plate}${subleaseChangeData.reason ? ": " + subleaseChangeData.reason : ""} (${subleaseChangeData.date})`
    );

    setSubleaseChangeModal(false);
    refreshData();
  };

  const onCarSelected = (newCarId, meta = {}) => {
    // Look up the car info from the search results — ChangeCarModal passes the ID
    // plus the user-picked change date so we don't ask for it twice.
    setCarChangeStep({ newCarId });
    setCarChangeReason("");
    setCarChangeDate(meta.changeDate || moment().format("YYYY-MM-DD"));
    setChangeCarModal(false);
  };

  const getDaysElapsed = () => {
    if (!resDetails.date_range) return 0;
    const clean = resDetails.date_range.replace(/[\[\]()]/g, "");
    const startStr = clean.split(",")[0]?.replace(/"/g, "").trim();
    if (!startStr) return 0;
    const start = moment(startStr);
    const changeAt = moment(carChangeDate);
    return Math.max(0, Math.floor(changeAt.diff(start, "days", true)));
  };

  const confirmCarChange = async () => {
    const wasSublease = !!resDetails.is_sublease;
    const previousCarId = resDetails.car?.id || null;
    const previousSubleasePlate = resDetails.sublease_plate || "";
    const dailyPrice = resDetails.totals?.dailyPrice || 0;
    const changeTimestamp = `${carChangeDate} 00:00:00+00`;

    // Log the change. For sublease → fleet swaps, tag the reason so the
    // history rendering can show "Subarrendado (PLATE) → Versa (RN8737B)".
    const taggedReason = wasSublease
      ? `[Desde Subarrendado ${previousSubleasePlate}]${carChangeReason ? " " + carChangeReason : ""}`
      : carChangeReason || null;

    await supabase.from("reservation_car_changes").insert({
      reservation_id: reservationId,
      previous_car_id: previousCarId,
      new_car_id: carChangeStep.newCarId,
      // Ver nota en confirmSubleaseChange: los reportes leen estas columnas.
      previous_sublease_plate: wasSublease ? normPlate(previousSubleasePlate) : null,
      new_sublease_plate: null,
      reason: taggedReason,
      daily_price_changed: false,
      previous_daily_price: dailyPrice,
      new_daily_price: dailyPrice,
      changed_by: session?.user?.id,
      changed_at: changeTimestamp,
    });

    // Swap the car. If the reservation was sublease, also clear the sublease
    // fields and flip is_sublease back to false.
    const updates = { car: carChangeStep.newCarId };
    if (wasSublease) {
      updates.is_sublease = false;
      updates.sublease_plate = null;
      updates.sublease_vin = null;
      updates.sublease_model_id = null;
    }
    const { error } = await supabase
      .from("reservations")
      .update(updates)
      .eq("id", reservationId);

    if (error) {
      alert("Error: " + error.message);
      return;
    }

    await logAudit(
      wasSublease ? "sublease_to_fleet" : "car_change",
      {
        previous_car: previousCarId,
        previous_sublease_plate: previousSubleasePlate || null,
        new_car: carChangeStep.newCarId,
        reason: carChangeReason,
        date: carChangeDate,
      },
      wasSublease
        ? `Cambio de subarrendado ${previousSubleasePlate} a auto propio${carChangeReason ? ": " + carChangeReason : ""} (${carChangeDate})`
        : `Cambio de auto${carChangeReason ? `: ${carChangeReason}` : ""} (${carChangeDate})`
    );

    setCarChangeStep(null);
    refreshData();
  };

  const openDeliveryEdit = () => {
    setDeliveryForm({
      delivery_type: resDetails.delivery?.type || "sucursal",
      delivery_address: resDetails.delivery?.address || "",
      delivery_fee: resDetails.delivery?.fee ?? 500,
      delivery_notes: resDetails.delivery?.notes || "",
      return_type: resDetails.return?.type || "sucursal",
      return_address: resDetails.return?.address || "",
      return_fee: resDetails.return?.fee ?? 500,
      return_notes: resDetails.return?.notes || "",
    });
    setDeliveryModal(true);
  };

  const saveDelivery = async () => {
    const dFee = deliveryForm.delivery_type === "domicilio" ? (parseInt(deliveryForm.delivery_fee) || 0) : 0;
    const rFee = deliveryForm.return_type === "domicilio" ? (parseInt(deliveryForm.return_fee) || 0) : 0;
    const totalRent = resDetails.totals?.totalRent || 0;
    const newTotalPrice = totalRent + dFee + rFee;
    const { error } = await supabase
      .from("reservations")
      .update({
        delivery: {
          type: deliveryForm.delivery_type,
          address: deliveryForm.delivery_type === "sucursal" ? "Oficina Central - Colón" : deliveryForm.delivery_address,
          fee: dFee,
          notes: deliveryForm.delivery_notes,
        },
        return: {
          type: deliveryForm.return_type,
          address: deliveryForm.return_type === "sucursal" ? "Oficina Central - Colón" : deliveryForm.return_address,
          fee: rFee,
          notes: deliveryForm.return_notes,
        },
        delivery_location_id: deliveryForm.delivery_type === "sucursal" ? 1 : 2,
        return_location_id: deliveryForm.return_type === "sucursal" ? 1 : 2,
        total_price: newTotalPrice,
      })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    setDeliveryModal(false);
    refreshData();
  };

  const changeCompany = async ({ id }) => {
    const { error } = await supabase
      .from("reservations")
      .update({ company: id })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }
    refreshData();
  };

  const saveEditTotal = async (newValue) => {
    if (pricePeriodsError) {
      alert("Los periodos de tarifa no se pudieron cargar, por lo que la sección vigente podría estar desactualizada. Recarga la página antes de modificar la tarifa.");
      return;
    }
    const key = editTotal.key;
    const val = parseInt(newValue);

    // dailyPrice edits are handled by the section-aware changeRateModal — the
    // inline Tarifa Diaria click opens that flow directly. This branch only
    // handles deposit / hoursExtra / totalRent edits.
    let deposit = key === "deposit" ? val : resDetails.totals.deposit;
    let totalRent = key === "totalRent" ? val : resDetails.totals.totalRent;
    let hoursExtra = key === "hoursExtra" ? val : resDetails.totals.hoursExtra;
    const { days } = resDetails.rent_time || { days: 1 };
    let dailyPrice = resDetails.totals.dailyPrice;
    if (key === "hoursExtra") {
      totalRent = (dailyPrice * days) + hoursExtra;
    } else if (key === "totalRent") {
      // Derive a new daily_price so the section drives the same total. Without
      // this, the next date_range change would resync totals to
      // (old dailyPrice × new days) and silently overwrite the manual edit.
      dailyPrice = days > 0 ? totalRent / days : totalRent;
    }

    // totalRent edits propagate to the open section so future resyncs respect
    // the manual override; deposit/hoursExtra don't change the section state.
    if (key === "totalRent") {
      const openSection = pricePeriods.find((p) => p.effective_to == null);
      if (openSection) {
        const { error: errPrice } = await supabase
          .from("reservation_price_periods")
          .update({ daily_price: dailyPrice, billable_amount: null })
          .eq("id", openSection.id);
        if (errPrice) {
          alert("Error: " + errPrice.message);
          return;
        }
      }
    }

    const newTotals = { ...resDetails.totals, dailyPrice, deposit, totalRent, hoursExtra };
    const deliveryFee = resDetails.delivery?.fee || 0;
    const returnFee = resDetails.return?.fee || 0;
    const totalPrice = totalRent + deliveryFee + returnFee;
    const { error } = await supabase
      .from("reservations")
      .update({ totals: newTotals, total_price: totalPrice, deposit })
      .eq("id", reservationId);
    if (error) {
      alert("Error: " + error.message);
      return;
    }

    if (key === "totalRent") {
      // Run the canonical totals computation against the new section state so
      // total_price/balance/fully_paid match whatever the DB function would
      // produce on the next date_range change.
      const { error: errSync } = await resyncReservationTotals(reservationId);
      if (errSync) {
        alert("Error: " + errSync.message);
        return;
      }
    }

    refreshData();
    setEditTotal({ activated: false, key: undefined, value: undefined, title: undefined });
  };

  const isCancelled = resDetails.status === "cancelled" || resDetails.status === "completed";

  // Cuentas incobrables — moving this reservation's debt to collection handled
  // outside the day-to-day process. It takes the balance out of the Saldo a Hoy
  // worklist and into Cuentas Incobrables; the debt stays owed and on the books,
  // only who chases it changes. Both directions need `reservations.write_off`,
  // enforced by a trigger.
  const canWriteOff = hasPermission(WRITE_OFF_PERMISSION);
  const isWrittenOff = !!resDetails.written_off_at;
  // A debt can only be written off once the client is blocked — otherwise they
  // could keep booking and every new reservation would be a debt nobody chases.
  // "The client" is the billing entity: the company when there is one, else the
  // person. Mirrors the rule in enforce_write_off_authority.
  const writeOffClient = resDetails.company?.id
    ? resDetails.company
    : resDetails.customer;
  const writeOffClientBlocked = !!writeOffClient?.blocked;
  const [writeOffModal, setWriteOffModal] = useState(null); // "mark" | "clear" | null
  const [writeOffNotes, setWriteOffNotes] = useState("");
  const [writeOffSaving, setWriteOffSaving] = useState(false);

  const confirmWriteOff = async () => {
    setWriteOffSaving(true);
    const { error } =
      writeOffModal === "clear"
        ? await clearWriteOff(reservationId)
        : await markWriteOff({
            reservationId,
            notes: writeOffNotes,
            userId: session?.user?.id,
          });
    setWriteOffSaving(false);
    if (error) {
      alert(error);
      return;
    }
    setWriteOffModal(null);
    refreshData();
  };

  // Only the current owner or a superadmin may reassign (commission guard,
  // enforced by trg_reservations_owner_change).
  const canChangeOwner =
    claims?.role === "superadmin" ||
    (!!resDetails.created_by && resDetails.created_by === session?.user?.id);
  const changeOwnerAction = canChangeOwner
    ? [{ content: "Cambiar Responsable", onAction: () => setChangeOwnerModal(true) }]
    : [];

  const pageActionGroups = [
    {
      title: "Operación",
      actions: [
        ...(!resDetails.checked_out && resDetails.type === "rental"
          ? [{
              content: "Entregar Auto",
              onAction: () => setInspectionModal({ open: true, type: "checkout" }),
            }]
          : []),
        ...(resDetails.checked_out && !resDetails.checked_in && resDetails.type === "rental"
          ? [{
              content: "Recibir Auto",
              onAction: () => setInspectionModal({ open: true, type: "checkin" }),
            }]
          : []),
        // Revert the entrega: only when the unit is out but not yet returned,
        // and the checkout was recorded with a revert snapshot.
        ...(resDetails.checked_out && !resDetails.checked_in && !isCancelled &&
          revertibleInspection("checkout")
          ? [{
              content: "Cancelar Entrega",
              destructive: true,
              onAction: () =>
                setRevertModal({
                  open: true,
                  type: "checkout",
                  inspectionId: revertibleInspection("checkout").id,
                  busy: false,
                }),
            }]
          : []),
        ...(resDetails.checked_in && resDetails.status === "active"
          ? [{
              content: "Completar Reserva",
              onAction: () => setCompleteModal(true),
            }]
          : []),
        // Revert the devolución: only while the reservation is still active
        // (not completed) and the checkin carries a revert snapshot.
        ...(resDetails.checked_in && resDetails.status === "active" &&
          !resDetails.deposit_returned && revertibleInspection("checkin")
          ? [{
              content: "Cancelar Devolución",
              destructive: true,
              onAction: () =>
                setRevertModal({
                  open: true,
                  type: "checkin",
                  inspectionId: revertibleInspection("checkin").id,
                  busy: false,
                }),
            }]
          : []),
        ...(!resDetails.deposit_returned && depositPaid > 0 && resDetails.checked_in && !clipRefundPending
          ? [{
              content: depositActionLabel,
              onAction: openDepositReturn,
            }]
          : []),
        ...(!resDetails.checked_out && resDetails.type === "rental"
          ? [{
              content: "No-Show",
              onAction: markNoShow,
            }]
          : []),
        ...(resDetails.type === "rental" && !isCancelled
          ? [{
              content: "Extender Reserva",
              onAction: () => {
                setExtendDate("");
                setExtendHour("09:00");
                setExtendApplyNewRate(false);
                setExtendNewRateDate("");
                setExtendNewRatePrice("");
                setExtendError("");
                setExtendModal(true);
              },
            }]
          : []),
        // Only a flag: the customer might keep the car longer. It changes the
        // bar on Ocupación and warns (not blocks) later bookings of the car.
        ...(resDetails.type === "rental" && resDetails.status === "active" && !resDetails.checked_in
          ? [{
              content: resDetails.possible_extension
                ? "Quitar posible extensión"
                : "Marcar posible extensión",
              onAction: togglePossibleExtension,
            }]
          : []),
        ...(resDetails.type === "rental" && !isCancelled
          ? [{
              content: "Cambiar Tarifa Diaria",
              onAction: openChangeRateModal,
            }]
          : []),
        // No cancellation once the unit is out (checked out) — finalize via
        // check-in instead. Also hidden for already cancelled/completed.
        ...(!resDetails.checked_out && !isCancelled
          ? [{
              content: "Cancelar Reserva",
              onAction: () => handleSecondaryActions("cancel"),
              destructive: true,
            }]
          : []),
        ...changeOwnerAction,
      ],
    },
    {
      title: "Pagos",
      actions: [
        {
          content: "Agregar Pago",
          onAction: () => handleSecondaryActions("add_payment"),
        },
        {
          content: "Agregar Depósito",
          onAction: () => handleSecondaryActions("add_deposit"),
        },
        {
          content: "Agregar Cargo Extra",
          onAction: () => setChargeModal(true),
        },
        {
          content: "Aplicar Descuento",
          onAction: () => setDiscountModal(true),
        },
        ...((resDetails.paid || 0) > (resDetails.total_price || 0)
          ? [
              {
                content: "Reembolso",
                onAction: openRefundModal,
              },
              {
                content: "Mover a Crédito del Cliente",
                onAction: openCreditModal,
              },
            ]
          : []),
        ...(canWriteOff
          ? [
              isWrittenOff
                ? {
                    content: "Quitar Incobrable",
                    onAction: () => setWriteOffModal("clear"),
                  }
                : {
                    content: "Marcar como Incobrable",
                    destructive: true,
                    // Shown but disabled rather than hidden, so the rule is
                    // discoverable instead of the option just being missing.
                    disabled: !writeOffClientBlocked,
                    helpText: writeOffClientBlocked
                      ? undefined
                      : resDetails.company?.id
                      ? "Primero bloquea a la empresa"
                      : "Primero bloquea al cliente",
                    onAction: () => {
                      setWriteOffNotes("");
                      setWriteOffModal("mark");
                    },
                  },
            ]
          : []),
      ],
    },
    {
      title: "Documentos",
      actions: [
        {
          content: "Contrato de Renta",
          onAction: () => generateContract("contrato_de_renta"),
        },
        {
          content: "Carta Cobertura",
          onAction: () => generateContract("carta_cobertura"),
        },
        {
          content: "Checklist",
          onAction: () => generateContract("checklist"),
        },
        {
          content: "Facturar",
          onAction: () => { setSubstituteInvoice(null); setInvoiceModal(true); },
        },
      ],
    },
    {
      title: "Más",
      actions: [
        {
          content: "Agregar Archivo",
          onAction: () => setFileUploadModal(true),
        },
      ],
    },
  ];

  const openInspectionPhoto = async (bucket, path) => {
    const { data } = await supabase.storage
      .from(bucket)
      .createSignedUrl(path, 60 * 60); // 1 hour is plenty for a click-view
    if (data?.signedUrl) window.open(data.signedUrl, "_blank");
  };

  const [signLinkModal, setSignLinkModal] = useState({
    open: false,
    url: "",
    inspectionType: "",
  });

  const generateSigningLink = async (inspectionType) => {
    const { data, error } = await supabase
      .from("reservation_signing_tokens")
      .insert({
        reservation_id: resDetails.id,
        inspection_type: inspectionType,
      })
      .select("token")
      .single();
    if (error) {
      alert("Error generando liga: " + error.message);
      return;
    }
    const url = `https://sign.gomoverent.com/${data.token}`;
    setSignLinkModal({ open: true, url, inspectionType });
  };

  // Resolve signed URLs for each inspection photo so we can render <img>
  // thumbnails directly. 2-hour expiry is plenty for a page session.
  const resolvePhotoUrls = async (insps) => {
    const enriched = await Promise.all(
      (insps || []).map(async (insp) => {
        const photos = await Promise.all(
          (insp.reservation_inspection_photos || []).map(async (p) => {
            const { data } = await supabase.storage
              .from("inspection-photos")
              .createSignedUrl(p.file_url, 60 * 60 * 2);
            return { ...p, url: data?.signedUrl || "" };
          })
        );
        return { ...insp, reservation_inspection_photos: photos };
      })
    );
    return enriched;
  };

  const inspectionsSection = () => {
    if (resDetails.id === undefined || resDetails.type !== "rental") return null;

    const pickLatest = (t) =>
      inspections.filter((i) => i.type === t).slice(-1)[0] || null;
    const checkout = pickLatest("checkout");
    const returnInsp = pickLatest("checkin");

    const renderOne = (insp, label) => {
      if (!insp) {
        return (
          <BlockStack gap="200">
            <InlineStack gap="200" align="space-between">
              <Text variant="headingSm">{label}</Text>
              <Badge tone="info">Pendiente</Badge>
            </InlineStack>
            <Text variant="bodySm" tone="subdued">
              No se ha capturado información.
            </Text>
          </BlockStack>
        );
      }
      const signed = !!insp.signature_image_url;
      const method = insp.signing_method;
      const photoCount = (insp.reservation_inspection_photos || []).length;
      const toneBadge = signed ? "success" : "warning";
      const statusLabel = signed
        ? `Firmada${method ? ` · ${method}` : ""}`
        : "Esperando firma";
      return (
        <BlockStack gap="200">
          <InlineStack gap="200" align="space-between">
            <Text variant="headingSm">{label}</Text>
            <Badge tone={toneBadge}>{statusLabel}</Badge>
          </InlineStack>
          <InlineGrid columns={2} gap="200">
            <Text variant="bodySm">
              <strong>Odómetro:</strong> {insp.odometer ?? "—"} km
            </Text>
            <Text variant="bodySm">
              <strong>Combustible:</strong>{" "}
              {insp.fuel_level ? `${insp.fuel_level}/16` : "—"}
            </Text>
            {insp.signed_by_name && (
              <Text variant="bodySm">
                <strong>Firmó:</strong> {insp.signed_by_name}
              </Text>
            )}
            {insp.signed_at && (
              <Text variant="bodySm">
                <strong>Fecha:</strong>{" "}
                {moment.utc(insp.signed_at).format("DD/MM/YYYY HH:mm")}
              </Text>
            )}
          </InlineGrid>
          {insp.notes && (
            <Text variant="bodySm" tone="subdued">
              {insp.notes}
            </Text>
          )}
          {photoCount > 0 && (
            <>
              <Text variant="bodySm" tone="subdued">
                {photoCount} fotografía{photoCount === 1 ? "" : "s"} — clic para
                ampliar
              </Text>
              <InlineStack gap="200" wrap>
                {(insp.reservation_inspection_photos || []).map((p) => (
                  <div
                    key={p.file_url}
                    onClick={() =>
                      openInspectionPhoto("inspection-photos", p.file_url)
                    }
                    title={(p.label || p.file_name || "foto").replace(/_/g, " ")}
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: 6,
                      overflow: "hidden",
                      background: "#f1f2f3",
                      cursor: "pointer",
                      border: "1px solid #e1e3e5",
                    }}
                  >
                    {p.url ? (
                      <img
                        src={p.url}
                        alt={p.label || "foto"}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    ) : null}
                  </div>
                ))}
              </InlineStack>
            </>
          )}
          {signed && (
            <Button
              size="slim"
              onClick={() =>
                openInspectionPhoto(
                  "inspection-signatures",
                  insp.signature_image_url
                )
              }
            >
              Ver firma
            </Button>
          )}
          {!signed && (
            <Button
              size="slim"
              variant="primary"
              onClick={() => generateSigningLink(insp.type)}
            >
              Enviar liga de firma
            </Button>
          )}
        </BlockStack>
      );
    };

    return (
      <Card>
        <BlockStack gap="400">
          <Text variant="headingMd">Inspecciones</Text>
          {renderOne(checkout, "Entrega")}
          <Divider />
          {renderOne(returnInsp, "Devolución")}
        </BlockStack>
      </Card>
    );
  };

  const customerSection = () => {
    if (resDetails.id === undefined || !resDetails.customer) return null;

    const getLicenceState = () => {
      if (!resDetails.customer?.license_expiration) return { expired: false };
      const licenseExpiration = moment(
        resDetails.customer.license_expiration,
        "YYYY-MM-DD"
      );
      const clean = (resDetails.date_range || "").replace(/[\[\]()]/g, "");
      const endStr = clean.split(",")[1]?.replace(/"/g, "").trim() || "";
      if (!endStr || endStr === "infinity" || endStr === "") return { expired: false };
      const reservation_finish_date = moment(endStr.substring(0, 16), "YYYY-MM-DD HH:mm");
      const days_until_expires_after_res = licenseExpiration.diff(
        reservation_finish_date,
        "days"
      );
      const today = moment();
      const daysExpired = licenseExpiration.diff(today, "days");
      if (daysExpired <= 0) {
        return {
          message: `Licencia expiró hace ${daysExpired * -1} dias.`,
          expired: true,
        };
      }
      if (days_until_expires_after_res <= 0) {
        return {
          message: `Licencia expira ${
            days_until_expires_after_res * -1
          } dias antes de terminar reserva.`,
          expired: true,
        };
      }
      return { expired: false };
    };
    const licence_expiration = getLicenceState();

    return (
      <div>
        {resDetails.company && <Text variant="headingSm">Persona</Text>}
        <Button variant="plain" url={`/customers/edit?id=${resDetails.customer.id}`}>
          {resDetails.customer.first_name} {resDetails.customer.last_name}
        </Button>
        <Text>{resDetails.customer.phone}</Text>
        {resDetails.customer.email ? (
          <Text>{resDetails.customer.email}</Text>
        ) : (
          <></>
        )}
        <br />
        <div>
          {!licence_expiration.expired ? (
            <></>
          ) : (
            <div>
              <Tooltip
                content={<Text as="span">{licence_expiration.message}</Text>}
              >
                <Badge tone="critical">Licencia Expirada</Badge>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    );
  };

  const companySection = () => {
    if (!resDetails.id || !resDetails.company) return null;
    return (
      <div>
        <Text variant="headingSm">Empresa</Text>
        <Button variant="plain" url={`/companies/edit?id=${resDetails.company.id}`}>
          {resDetails.company.name}
        </Button>
        {resDetails.company.rfc && (
          <Text tone="subdued">{resDetails.company.rfc}</Text>
        )}
        {resDetails.company.contact_phone && (
          <Text tone="subdued">{resDetails.company.contact_phone}</Text>
        )}
      </div>
    );
  };


  return (
    <AppWrapper>
      <AddPayment
        activated={paymentsWindow.active}
        type="deposit"
        deposit={paymentsWindow.isDeposit}
        setActivated={(e) =>
          setPaymentsWindow({ ...paymentsWindow, active: e })
        }
        reservation={resDetails.id}
        customer={resDetails.customer?.id || undefined}
        company={resDetails.company?.id || undefined}
        onPaymentSaved={refreshData}
      />
      <Modal
        open={deliveryModal}
        onClose={() => setDeliveryModal(false)}
        title="Entrega y Devolución"
        primaryAction={{
          content: "Guardar",
          onAction: saveDelivery,
        }}
        secondaryActions={[
          { content: "Cancelar", onAction: () => setDeliveryModal(false) },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <Text variant="headingSm">Entrega</Text>
            <Select
              label="Tipo de Entrega"
              value={deliveryForm.delivery_type}
              options={[
                { label: "Recoger en sucursal", value: "sucursal" },
                { label: "Entrega a domicilio", value: "domicilio" },
              ]}
              onChange={(val) =>
                setDeliveryForm({ ...deliveryForm, delivery_type: val })
              }
            />
            {deliveryForm.delivery_type === "domicilio" && (
              <>
                <TextField
                  label="Dirección de Entrega"
                  value={deliveryForm.delivery_address}
                  onChange={(val) =>
                    setDeliveryForm({ ...deliveryForm, delivery_address: val })
                  }
                  placeholder="Calle, colonia, ciudad"
                />
                <TextField
                  label="Cargo por entrega"
                  value={String(deliveryForm.delivery_fee)}
                  onChange={(val) =>
                    setDeliveryForm({ ...deliveryForm, delivery_fee: val })
                  }
                  type="number"
                  prefix="$"
                />
              </>
            )}
            <TextField
              label="Notas de Entrega"
              value={deliveryForm.delivery_notes}
              onChange={(val) =>
                setDeliveryForm({ ...deliveryForm, delivery_notes: val })
              }
              multiline={2}
            />
            <Text variant="headingSm">Devolución</Text>
            <Select
              label="Tipo de Devolución"
              value={deliveryForm.return_type}
              options={[
                { label: "Devolver en sucursal", value: "sucursal" },
                { label: "Recoger a domicilio", value: "domicilio" },
              ]}
              onChange={(val) =>
                setDeliveryForm({ ...deliveryForm, return_type: val })
              }
            />
            {deliveryForm.return_type === "domicilio" && (
              <>
              <TextField
                label="Dirección de Devolución"
                value={deliveryForm.return_address}
                onChange={(val) =>
                  setDeliveryForm({ ...deliveryForm, return_address: val })
                }
                placeholder="Calle, colonia, ciudad"
              />
              <TextField
                label="Cargo por recolección"
                value={String(deliveryForm.return_fee)}
                onChange={(val) =>
                  setDeliveryForm({ ...deliveryForm, return_fee: val })
                }
                type="number"
                prefix="$"
              />
              </>
            )}
            <TextField
              label="Notas de Devolución"
              value={deliveryForm.return_notes}
              onChange={(val) =>
                setDeliveryForm({ ...deliveryForm, return_notes: val })
              }
              multiline={2}
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={fileUploadModal}
        onClose={() => { setFileUploadModal(false); setFilesToUpload([]); }}
        title="Agregar Archivos"
        primaryAction={{
          content: "Subir",
          onAction: uploadFiles,
          disabled: filesToUpload.length === 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => { setFileUploadModal(false); setFilesToUpload([]); } }]}
      >
        <Modal.Section>
          <BlockStack gap="200">
            <DropZone onDrop={(_drop, accepted) => setFilesToUpload((prev) => [...prev, ...accepted])} variableHeight>
              <DropZone.FileUpload actionTitle="Subir archivos" />
            </DropZone>
            {filesToUpload.map((f, i) => (
              <Text key={i} variant="bodySm">{f.name}</Text>
            ))}
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={extendModal}
        onClose={() => setExtendModal(false)}
        title="Extender Reserva"
        primaryAction={{
          content: "Extender",
          onAction: extendReservation,
          disabled: !extendDate,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setExtendModal(false) }]}
      >
        <Modal.Section>
          <FormLayout>
            <FormLayout.Group condensed>
              <TextField
                label="Nueva Fecha de Devolución"
                type="date"
                value={extendDate}
                onChange={setExtendDate}
              />
              <Select
                label="Hora"
                options={hoursOfDay}
                value={extendHour}
                onChange={setExtendHour}
              />
            </FormLayout.Group>
            <Checkbox
              label="Aplicar nueva tarifa desde una fecha"
              checked={extendApplyNewRate}
              onChange={setExtendApplyNewRate}
              helpText={
                extendApplyNewRate
                  ? "Se cerrará la sección actual el día anterior y se creará una nueva sección desde la fecha indicada."
                  : "Se conserva la tarifa actual durante todo el periodo extendido."
              }
            />
            {extendApplyNewRate && (
              <FormLayout.Group condensed>
                <TextField
                  label="Desde fecha"
                  type="date"
                  value={extendNewRateDate}
                  onChange={setExtendNewRateDate}
                />
                <TextField
                  label="Nueva tarifa diaria"
                  type="number"
                  prefix="$"
                  value={extendNewRatePrice}
                  onChange={setExtendNewRatePrice}
                />
              </FormLayout.Group>
            )}
            {extendError && <Banner tone="critical">{extendError}</Banner>}
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={changeRateModal}
        onClose={() => setChangeRateModal(false)}
        title="Editar Tarifa Diaria"
        primaryAction={{
          content: "Guardar",
          onAction: saveChangeRate,
          loading: changeRateSaving,
          disabled:
            changeRateSaving ||
            !changeRateForm.price ||
            (!changeRateForm.wholeReservation && !changeRateForm.date),
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setChangeRateModal(false) }]}
      >
        <Modal.Section>
          <FormLayout>
            <Text variant="bodySm" tone="subdued">
              Tarifa vigente: <strong>{formatPrice(resDetails.totals?.dailyPrice || 0)}/día</strong>.
              {changeRateForm.wholeReservation
                ? " La nueva tarifa reemplazará la tarifa de todos los días de la reservación."
                : " La tarifa actual se mantendrá hasta el día anterior a la fecha indicada y a partir de esa fecha se aplicará la nueva tarifa."}
            </Text>
            {pricePeriodsError && (
              <Banner tone="critical">
                No se pudieron cargar los periodos de tarifa ({pricePeriodsError}). Recarga la página antes de modificar la tarifa.
              </Banner>
            )}
            {(() => {
              const minDate = computeMinChangeDate();
              const latestStampedEnd = issuedInvoices
                .filter((i) => i.stamped && i.status !== "void" && i.period_to)
                .reduce((acc, i) => (!acc || i.period_to > acc ? i.period_to : acc), null);
              return latestStampedEnd ? (
                <Banner tone="warning">
                  Esta reservación tiene facturas timbradas hasta el <strong>{formatDate(latestStampedEnd)}</strong>. La nueva tarifa sólo puede iniciar desde <strong>{formatDate(minDate)}</strong> en adelante. Para modificar tarifas dentro de fechas ya facturadas, emite una nota de crédito primero.
                </Banner>
              ) : null;
            })()}
            <TextField
              label="Nueva tarifa diaria"
              type="number"
              prefix="$"
              value={changeRateForm.price}
              onChange={(v) => setChangeRateForm({ ...changeRateForm, price: v })}
            />
            <Checkbox
              label="Aplicar a toda la reservación"
              checked={changeRateForm.wholeReservation}
              onChange={(checked) =>
                setChangeRateForm({ ...changeRateForm, wholeReservation: checked })
              }
              helpText="Reemplaza la tarifa para todos los días de la reservación. Desmarca para programar el cambio desde una fecha específica."
            />
            {!changeRateForm.wholeReservation && (() => {
              const minStamped = computeMinChangeDate();
              const { start: resStart, end: resEnd } = getReservationDateBounds();
              const minDate = [minStamped, resStart].filter(Boolean).sort().pop() || undefined;
              return (
                <TextField
                  label="Desde fecha"
                  type="date"
                  value={changeRateForm.date}
                  min={minDate}
                  max={resEnd || undefined}
                  onChange={(v) => setChangeRateForm({ ...changeRateForm, date: v })}
                  helpText={`Por defecto: hoy. Debe estar dentro de la reservación${resStart && resEnd ? ` (${resStart} – ${resEnd})` : ""}.`}
                />
              );
            })()}
            <TextField
              label="Motivo (opcional)"
              value={changeRateForm.reason}
              onChange={(v) => setChangeRateForm({ ...changeRateForm, reason: v })}
              placeholder="Ej. Renegociación de tarifa, descuento por antigüedad…"
            />
            {changeRateError && <Banner tone="critical">{changeRateError}</Banner>}
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={dateEditModal.open}
        onClose={() => setDateEditModal({ ...dateEditModal, open: false })}
        title={dateEditModal.type === "entrega" ? "Editar Fecha de Entrega" : "Editar Fecha de Devolución"}
        primaryAction={{
          content: "Guardar",
          onAction: saveDateEdit,
          disabled: !dateEditModal.date,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setDateEditModal({ ...dateEditModal, open: false }) }]}
      >
        <Modal.Section>
          <FormLayout>
            <FormLayout.Group condensed>
              <TextField
                label="Fecha"
                type="date"
                value={dateEditModal.date}
                onChange={(val) => setDateEditModal({ ...dateEditModal, date: val })}
              />
              <Select
                label="Hora"
                options={hoursOfDay}
                value={dateEditModal.hour}
                onChange={(val) => setDateEditModal({ ...dateEditModal, hour: val })}
              />
            </FormLayout.Group>
            <Checkbox
              label="Recalcular precio diario desde la tarifa"
              checked={dateEditModal.recalc && !resDetails.is_sublease}
              disabled={!!resDetails.is_sublease}
              onChange={(val) => setDateEditModal({ ...dateEditModal, recalc: val })}
              helpText={
                resDetails.is_sublease
                  ? "Subarrendado: se conserva la tarifa diaria actual."
                  : dateEditModal.recalc
                  ? "El precio se ajustará según la tabla de tarifas."
                  : "Se conserva la tarifa diaria actual y sólo se extienden los días."
              }
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={chargeModal}
        onClose={() => setChargeModal(false)}
        title="Agregar Cargo Extra"
        primaryAction={{
          content: "Agregar",
          onAction: addCharge,
          disabled: !newCharge.description || !newCharge.amount,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setChargeModal(false) }]}
      >
        <Modal.Section>
          <FormLayout>
            <Select
              label="Tipo"
              value={newCharge.charge_type}
              options={[
                { label: "Daño", value: "damage" },
                { label: "Combustible", value: "fuel" },
                { label: "Limpieza profunda", value: "cleaning" },
                { label: "Multa", value: "fine" },
                { label: "Peaje", value: "toll" },
                { label: "Otro", value: "other" },
              ]}
              onChange={(val) => setNewCharge({ ...newCharge, charge_type: val })}
            />
            <TextField
              label="Descripción"
              value={newCharge.description}
              onChange={(val) => setNewCharge({ ...newCharge, description: val })}
            />
            <TextField
              label="Monto"
              value={newCharge.amount}
              onChange={(val) => setNewCharge({ ...newCharge, amount: val })}
              prefix="$"
              type="number"
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={writeOffModal === "mark"}
        onClose={() => setWriteOffModal(null)}
        title="Marcar como incobrable"
        primaryAction={{
          content: "Marcar",
          destructive: true,
          loading: writeOffSaving,
          disabled: writeOffSaving,
          onAction: confirmWriteOff,
        }}
        secondaryActions={[
          { content: "Cancelar", onAction: () => setWriteOffModal(null) },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <Text>
              El saldo de esta reservación ({formatPrice(resDetails.balance || 0)})
              sale de la cobranza del día a día y pasa al reporte de Cuentas
              Incobrables, para gestionarse por fuera. No se cancela ni se
              condona nada: la deuda sigue vigente y registrada.
            </Text>
            <Text tone="subdued">
              {writeOffClient?.name ||
                `${writeOffClient?.first_name || ""} ${
                  writeOffClient?.last_name || ""
                }`.trim()}{" "}
              ya está bloqueado, así que no podrá generar reservaciones nuevas.
            </Text>
            <TextField
              label="Nota"
              value={writeOffNotes}
              onChange={setWriteOffNotes}
              multiline={3}
              autoComplete="off"
              placeholder="Cómo se va a gestionar la cobranza"
              helpText="Se muestra en el reporte de Cuentas Incobrables."
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
      <Modal
        open={writeOffModal === "clear"}
        onClose={() => setWriteOffModal(null)}
        title="Quitar incobrable"
        primaryAction={{
          content: "Quitar",
          loading: writeOffSaving,
          disabled: writeOffSaving,
          onAction: confirmWriteOff,
        }}
        secondaryActions={[
          { content: "Cancelar", onAction: () => setWriteOffModal(null) },
        ]}
      >
        <Modal.Section>
          <Text>
            El saldo regresa a la cobranza normal: reaparece en Saldo a Hoy y se
            quita del reporte de Cuentas Incobrables. La nota registrada se
            borra.
          </Text>
        </Modal.Section>
      </Modal>
      <Modal
        open={depositReturnModal}
        onClose={() => setDepositReturnModal(false)}
        title={depositActionLabel}
        primaryAction={
          cardActive
            ? {
                content: `Devolver ${formatPrice(depositToReturn)}`,
                onAction: async () => {
                  // Same as Fintoc: pagos-svc sends deposit − pending, so the
                  // pending part is recorded as paid from the deposit first.
                  if (!(await chargeDepositToRent())) return;
                  setDepositReturnModal(false);
                  setCardConfirmOpen(true);
                },
                disabled: !cardReturn.ready || depositToReturn <= 0,
              }
            : clipActive
            ? {
                content: `Devolver ${formatPrice(depositToReturn)}`,
                onAction: async () => {
                  // pagos-svc refunds deposit − pending; the pending part is
                  // recorded as paid from the deposit first, as for Fintoc.
                  if (!(await chargeDepositToRent())) return;
                  setDepositReturnModal(false);
                  setClipConfirmOpen(true);
                },
                disabled: depositToReturn <= 0,
              }
            : fintocActive
            ? {
                content: `Devolver ${formatPrice(depositToReturn)}`,
                onAction: async () => {
                  // pagos-svc only sends back deposit − pending; the pending
                  // part has to be recorded as paid here, from the deposit,
                  // or the reservation keeps showing it as owed.
                  if (!(await chargeDepositToRent())) return;
                  setDepositReturnModal(false);
                  setFintocConfirmOpen(true);
                },
                disabled: !fintocDestination || depositToReturn <= 0,
              }
            : {
                content: depositFullyCharged
                  ? `Cobrar ${formatPrice(depositChargeAmount)} de la garantía`
                  : depositReturnToCredit
                    ? `Enviar ${formatPrice(depositToReturn)} a crédito`
                    : `Devolver ${formatPrice(depositToReturn)}`,
                onAction: confirmReturnDeposit,
                disabled: depositToReturn <= 0 && pendingBalance <= 0,
              }
        }
        secondaryActions={[{ content: "Cancelar", onAction: () => setDepositReturnModal(false) }]}
        large
      >
        <Modal.Section>
          <BlockStack gap="400">
            <InlineGrid columns="1fr auto">
              <Text variant="headingSm">Depósito Original</Text>
              <Text variant="headingMd">{formatPrice(resDetails.deposit || 0)}</Text>
            </InlineGrid>

            {pendingBalance > 0 && (
              <>
                <Divider />
                <InlineGrid columns="1fr auto">
                  <Text variant="headingSm">Saldo Pendiente</Text>
                  <Text fontWeight="bold" tone="critical">-{formatPrice(pendingBalance)}</Text>
                </InlineGrid>
                {existingChargesTotal > 0 && (
                  <BlockStack gap="100">
                    <Text variant="bodySm" tone="subdued">
                      Incluye cargos extra:
                    </Text>
                    {charges.map((c) => (
                      <InlineGrid key={c.id} columns="1fr auto">
                        <Text variant="bodySm" tone="subdued">{c.description}</Text>
                        <Text variant="bodySm">{formatPrice(c.amount)}</Text>
                      </InlineGrid>
                    ))}
                  </BlockStack>
                )}
                <Text variant="bodySm" tone="subdued">Se cobrará del depósito</Text>
              </>
            )}

            <Divider />
            {depositFullyCharged ? (
              <BlockStack gap="100">
                <InlineGrid columns="1fr auto">
                  <Text variant="headingMd">Garantía a cobrar</Text>
                  <Text variant="headingMd">{formatPrice(depositChargeAmount)}</Text>
                </InlineGrid>
                <Text variant="bodySm" tone="subdued">
                  El cliente debe el depósito completo: no se devuelve nada y la garantía se
                  aplica como pago al saldo pendiente
                  {pendingBalance > depositPaid
                    ? ` (quedan ${formatPrice(pendingBalance - depositPaid)} por cobrar).`
                    : "."}
                </Text>
              </BlockStack>
            ) : (
              <InlineGrid columns="1fr auto">
                <Text variant="headingMd" tone="success">
                  {depositReturnToCredit ? "A Crédito del Cliente" : "A Devolver"}
                </Text>
                <Text variant="headingMd" tone="success">{formatPrice(depositToReturn)}</Text>
              </InlineGrid>
            )}

            {totalDeductions === 0 && (
              <Text variant="bodySm" tone="success">Sin deducciones — depósito completo a devolver.</Text>
            )}

            <Divider />
            {!depositFullyCharged && (
              <Checkbox
                label="Enviar a crédito del cliente"
                checked={depositReturnToCredit}
                onChange={setDepositReturnToCredit}
                disabled={depositToReturn <= 0}
                helpText={`Suma ${formatPrice(depositToReturn)} al saldo a favor del cliente en lugar de devolverlo en efectivo. No es una salida de caja.`}
              />
            )}
            {!depositReturnToCredit && !depositFullyCharged &&
              (() => {
                // A deposit that arrived through Fintoc goes back through
                // Fintoc, to the account it came from. There is no second way
                // to send it, so there is no method to choose and no panel
                // explaining the choice — the confirmation step states where
                // the money lands. Every other deposit keeps the picker it has
                // always had.
                if (fintocReturnEligible) return null;
                // A Clip-charged deposit goes back by SPEI to the payer's
                // bank-verified CLABE (while Clip refunds are off).
                if (cardReturnEligible) {
                  return <CardReturnAccount reservationId={parseInt(reservationId)} onReady={setCardReturn} />;
                }
                // A Clip-charged deposit goes back as a refund to that card.
                if (clipReturnEligible) {
                  return (
                    <Text variant="bodySm" tone="subdued">
                      Se reembolsa a la tarjeta
                      {clipSource.payment?.card_last4 ? ` ···${clipSource.payment.card_last4}` : ""} con
                      la que se pagó (cobro Clip {clipSource.payment?.external_id}).
                    </Text>
                  );
                }

                // Collapse bank accounts (Afirme, Base, etc.) into a single
                // "Transferencia SPEI" option — staff doesn't pick which bank.
                // The internal "Crédito de cliente" account is intentionally
                // excluded — sending to credit is the checkbox above, not a
                // payout account.
                // Fintoc (account 7) is never a MANUAL transfer destination:
                // it is only reachable through the automatic option above, so
                // manual SPEI keeps resolving to the same bank it did before.
                const banks = depositReturnAccounts.filter((a) => a.type === "bank" && a.id !== 7);
                // Clip is excluded: a Clip deposit is a sale, and "returning"
                // it here only set the flags. It goes back as a refund above,
                // or by hand through another method.
                const nonBanks = depositReturnAccounts.filter(
                  (a) => a.type !== "bank" && a.type !== "credit" && a.id !== CLIP_ACCOUNT_ID
                );
                const selectedIsBank = banks.some((b) => b.id === depositReturnAccount);
                const speiId = selectedIsBank
                  ? depositReturnAccount
                  : banks[0]?.id;
                const options = [
                  ...nonBanks.map((a) => ({ label: a.name, value: String(a.id) })),
                  ...(banks.length > 0
                    ? [{ label: "Transferencia SPEI", value: String(speiId) }]
                    : []),
                ];
                return (
                  <BlockStack gap="400">
                    <Select
                      label="Devolver mediante"
                      options={options}
                      value={depositReturnAccount != null ? String(depositReturnAccount) : ""}
                      onChange={(v) => setDepositReturnAccount(parseInt(v))}
                      helpText="Por defecto, el método del depósito original. Efectivo y tarjeta se marcan como transferidos automáticamente; SPEI queda pendiente de transferir."
                    />
                  </BlockStack>
                );
              })()}
          </BlockStack>
        </Modal.Section>
      </Modal>
      <ConfirmClipRefundModal
        open={clipConfirmOpen}
        reservationId={reservationId}
        onClose={() => {
          setClipConfirmOpen(false);
          setDepositReturnModal(true);
        }}
        onDone={() => {
          setClipConfirmOpen(false);
          setClipRefundTick((t) => t + 1);
          refreshData();
        }}
      />
      <ConfirmDepositReturnModal
        kind="card_deposit_return"
        open={cardConfirmOpen}
        amountCents={Math.round(depositToReturn * 100)}
        destination={cardReturn.destination}
        clientName={clientDisplayName}
        reservationId={reservationId}
        onClose={() => {
          setCardConfirmOpen(false);
          setDepositReturnModal(true);
        }}
        onDone={() => {
          setCardConfirmOpen(false);
          setClipRefundTick((t) => t + 1);
          refreshData();
        }}
      />
      <ConfirmDepositReturnModal
        open={fintocConfirmOpen}
        amountCents={Math.round(depositToReturn * 100)}
        destination={fintocDestination}
        clientName={clientDisplayName}
        reservationId={reservationId}
        onClose={() => {
          // "Regresar": back to the deposit modal with the choices intact.
          setFintocConfirmOpen(false);
          setDepositReturnModal(true);
        }}
        onDone={() => {
          setFintocConfirmOpen(false);
          refreshData();
        }}
      />
      <Modal
        open={completeModal}
        onClose={() => setCompleteModal(false)}
        title="Completar Reservación"
        primaryAction={{
          content: "Completar",
          onAction: completeReservation,
          disabled: getCompletionBlockers().length > 0,
        }}
        secondaryActions={[{ content: "Volver", onAction: () => setCompleteModal(false) }]}
      >
        <Modal.Section>
          {(() => {
            const blockers = getCompletionBlockers();
            if (blockers.length === 0) {
              return <Text>¿Marcar esta reservación como completada?</Text>;
            }
            return (
              <BlockStack gap="200">
                <Banner tone="critical">
                  <p>No se puede completar esta reservación. Resuelve lo siguiente:</p>
                </Banner>
                <BlockStack gap="100">
                  {blockers.map((b, i) => (
                    <Text key={i} variant="bodySm">• {b}</Text>
                  ))}
                </BlockStack>
              </BlockStack>
            );
          })()}
        </Modal.Section>
      </Modal>
      <Modal
        open={revertModal.open}
        onClose={() =>
          !revertModal.busy &&
          setRevertModal({ open: false, type: null, inspectionId: null, busy: false })
        }
        title={
          revertModal.type === "checkout"
            ? "Cancelar Entrega"
            : "Cancelar Devolución"
        }
        primaryAction={{
          content: revertModal.busy ? "Revirtiendo..." : "Sí, revertir",
          destructive: true,
          loading: revertModal.busy,
          onAction: revertInspection,
        }}
        secondaryActions={[
          {
            content: "Volver",
            disabled: revertModal.busy,
            onAction: () =>
              setRevertModal({ open: false, type: null, inspectionId: null, busy: false }),
          },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Banner tone="critical" title="Esta acción es irreversible">
              <p>
                No se puede deshacer. La inspección de{" "}
                {revertModal.type === "checkout" ? "entrega" : "devolución"} y sus
                fotos/firma se eliminarán permanentemente.
              </p>
            </Banner>
            <Text>Se revertirá por completo lo siguiente:</Text>
            <BlockStack gap="100">
              {revertModal.type === "checkout" ? (
                <>
                  <Text variant="bodySm">• La reserva volverá a estado "Pendiente de entrega".</Text>
                  <Text variant="bodySm">• Se restaurará la fecha/hora de salida programada y el kilometraje inicial.</Text>
                  <Text variant="bodySm">• Se restaurará el odómetro del auto.</Text>
                  <Text variant="bodySm">• Se eliminarán la inspección de entrega, fotos y firma.</Text>
                </>
              ) : (
                <>
                  <Text variant="bodySm">• La reserva volverá a estado "Entregada, pendiente de devolución".</Text>
                  <Text variant="bodySm">• Se restaurará la fecha/hora de retorno programada y el kilometraje final.</Text>
                  <Text variant="bodySm">• Se restaurará el odómetro del auto.</Text>
                  <Text variant="bodySm">• Se eliminará cualquier cargo por gasolina generado en la devolución.</Text>
                  <Text variant="bodySm">• Se eliminarán la inspección de devolución, fotos y firma.</Text>
                </>
              )}
            </BlockStack>
          </BlockStack>
        </Modal.Section>
      </Modal>
      <InspectionModal
        open={inspectionModal.open}
        onClose={() => setInspectionModal({ ...inspectionModal, open: false })}
        reservationId={resDetails.id}
        type={inspectionModal.type}
        onComplete={refreshData}
        currentOdometer={resDetails.car?.odometer}
        scheduledDate={resDetails.date_range}
      />
      <InvoiceModal
        open={invoiceModal}
        onClose={() => { setInvoiceModal(false); setSubstituteInvoice(null); }}
        reservation={resDetails}
        customer={resDetails.customer}
        company={resDetails.company}
        charges={charges}
        discounts={discounts}
        substitutesInvoice={substituteInvoice}
        onSuccess={refreshData}
      />
      <InvoiceActionsModal
        open={invoiceActions.open}
        invoice={invoiceActions.invoice}
        defaultEmail={
          resDetails.customer?.email || resDetails.company?.contact_email || ""
        }
        onClose={() => setInvoiceActions({ open: false, invoice: null })}
        onChanged={refreshData}
        onSubstitute={(inv) => {
          setSubstituteInvoice(inv);
          setInvoiceModal(true);
        }}
      />
      <Modal
        open={signLinkModal.open}
        onClose={() => setSignLinkModal({ open: false, url: "", inspectionType: "" })}
        title={`Liga de firma — ${signLinkModal.inspectionType === "checkout" ? "Entrega" : "Devolución"}`}
        primaryAction={{
          content: "Cerrar",
          onAction: () =>
            setSignLinkModal({ open: false, url: "", inspectionType: "" }),
        }}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Text variant="bodyMd">
              Comparte esta liga con el cliente. Válida 72 horas.
            </Text>
            <TextField
              value={signLinkModal.url}
              readOnly
              autoComplete="off"
              multiline={2}
              selectTextOnFocus
            />
            <InlineStack gap="200" wrap>
              <Button
                onClick={() => {
                  navigator.clipboard.writeText(signLinkModal.url);
                  alert("Liga copiada");
                }}
              >
                Copiar
              </Button>
              <Button
                onClick={() => {
                  const phone = (resDetails.customer?.phone || "").replace(
                    /\D/g,
                    ""
                  );
                  const msg = encodeURIComponent(
                    `Hola ${resDetails.customer?.first_name || ""}, firma tu contrato GoMove aquí: ${signLinkModal.url}`
                  );
                  const url = phone
                    ? `https://wa.me/${phone}?text=${msg}`
                    : `https://wa.me/?text=${msg}`;
                  window.open(url, "_blank");
                }}
              >
                WhatsApp
              </Button>
              <Button
                onClick={() => {
                  const to = resDetails.customer?.email || "";
                  const subject = encodeURIComponent(
                    "Firma de contrato GoMove"
                  );
                  const body = encodeURIComponent(
                    `Hola ${resDetails.customer?.first_name || ""},\n\nFirma tu contrato aquí: ${signLinkModal.url}\n\nLa liga vence en 72 horas.`
                  );
                  window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
                }}
              >
                Correo
              </Button>
            </InlineStack>
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={concilModal.open}
        onClose={() => setConcilModal({ open: false, type: null, item: null })}
        title="Conciliar"
        primaryAction={{
          content: "Aplicar",
          onAction: saveConciliation,
          loading: concilSaving,
          disabled:
            !concilAmount ||
            concilSaving ||
            (parseFloat(concilAmount) || 0) > concilMaxAmount + 0.01 ||
            (parseFloat(concilAmount) || 0) <= 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setConcilModal({ open: false, type: null, item: null }) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            {concilModal.type === "payment" && (
              <>
                <Text>Pago #{concilModal.item?.id} — {formatPrice(concilModal.item?.amount)} (Disponible: {formatPrice(concilModal.item?.unallocated_amount)})</Text>
                <Select
                  label="Asignar a factura"
                  options={issuedInvoices
                    .filter(inv => invoiceDue(inv) > 0.01)
                    .map(inv => ({
                      label: `${inv.invoice_number} — Debe: ${formatPrice(invoiceDue(inv))}`,
                      value: String(inv.id),
                    }))}
                  value={concilModal.targetId || ""}
                  onChange={handleConcilTargetChange}
                />
              </>
            )}
            {concilModal.type === "invoice" && (
              <>
                <Text>Factura {concilModal.item?.invoice_number} — Debe: {formatPrice(invoiceDue(concilModal.item))}</Text>
                <Select
                  label="Pago a aplicar"
                  options={payments
                    .filter(p => !p.isDeposit && (p.unallocated_amount || 0) > 0)
                    .map(p => ({
                      label: `Pago #${p.id} — ${formatDate(p.payment_date || p.created_at?.substring(0, 10))} — Disponible: ${formatPrice(p.unallocated_amount)}`,
                      value: String(p.id),
                    }))}
                  value={concilModal.targetId || ""}
                  onChange={handleConcilTargetChange}
                />
              </>
            )}
            <TextField
              label="Monto a conciliar"
              value={concilAmount}
              onChange={(v) => {
                const num = parseFloat(v);
                if (Number.isNaN(num) || v === "") {
                  setConcilAmount(v);
                  return;
                }
                if (num > concilMaxAmount) {
                  setConcilAmount(String(concilMaxAmount));
                } else {
                  setConcilAmount(v);
                }
              }}
              type="number"
              prefix="$"
              max={String(concilMaxAmount)}
              helpText={`Máximo: ${formatPrice(concilMaxAmount)}`}
              autoComplete="off"
            />
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={paymentDetail.open}
        onClose={() => setPaymentDetail({ open: false, payment: null, allocations: [], loading: false })}
        title={`Pago #${paymentDetail.payment?.id ?? ""}`}
        secondaryActions={[
          // Only offered inside the 2h grace window on still-clean money, and
          // only once allocations have loaded (so we don't offer to delete a
          // payment whose invoice links we haven't seen yet).
          ...(paymentDetail.payment &&
          !paymentDetail.payment.__indirect &&
          !paymentDetail.loading &&
          paymentDetail.allocations.length === 0 &&
          isPaymentDeletable(paymentDetail.payment)
            ? [
                {
                  content: "Eliminar",
                  destructive: true,
                  loading: !!paymentDetail.deleting,
                  onAction: deletePayment,
                },
              ]
            : []),
          { content: "Cerrar", onAction: () => setPaymentDetail({ open: false, payment: null, allocations: [], loading: false }) },
        ]}
        {...(() => {
          const p = paymentDetail.payment;
          if (!p || p.isDeposit || p.type === "refund") return {};
          // Client-level payment: its remaining credit is the client's, possibly
          // earmarked for another reservation. Conciliar it from /payments, not
          // from inside one reservation.
          if (p.__indirect) return {};
          const avail = p.unallocated_amount ?? (p.invoiced ? 0 : p.amount);
          if (avail <= 0.01) return {};
          return {
            primaryAction: {
              content: "Conciliar disponible",
              onAction: () => {
                const pay = { id: p.id, amount: p.amount, unallocated_amount: avail };
                setPaymentDetail({ open: false, payment: null, allocations: [], loading: false });
                openConcilFromPayment(pay);
              },
            },
          };
        })()}
      >
        <Modal.Section>
          {paymentDetail.payment && (() => {
            const p = paymentDetail.payment;
            const avail = p.unallocated_amount ?? (p.invoiced ? 0 : p.amount);
            const conciliado = Math.round((p.amount - avail) * 100) / 100;
            const kind = p.type === "refund" ? "Reembolso" : p.isDeposit ? "Depósito" : "Pago";
            return (
              <BlockStack gap="300">
                <InlineStack align="space-between">
                  <Text tone="subdued">{kind} · {p.account?.name || "—"}</Text>
                  <Text tone="subdued">{formatDate(p.payment_date || p.created_at?.substring(0, 10))}</Text>
                </InlineStack>
                <InlineStack align="space-between">
                  <Text variant="headingMd">Monto</Text>
                  <Text variant="headingMd">{formatPrice(p.amount)}</Text>
                </InlineStack>
                {p.__indirect && (
                  <Text variant="bodySm" tone="subdued">
                    Pago a nivel cliente: no está ligado a esta reservación, se
                    aplicó a sus facturas. De este monto,{" "}
                    <b>{formatPrice(p.appliedHere)}</b> corresponde a esta
                    reservación; el resto puede pertenecer a otras. Para
                    modificarlo o conciliar el saldo, hazlo desde Pagos.
                  </Text>
                )}
                {p.card_last4 && (
                  <InlineStack align="space-between">
                    <Text tone="subdued">
                      {p.card_type === "credit"
                        ? "Tarjeta de crédito"
                        : p.card_type === "debit"
                        ? "Tarjeta de débito"
                        : "Tarjeta"}
                    </Text>
                    <Text tone="subdued">•••• {p.card_last4}</Text>
                  </InlineStack>
                )}
                {!p.isDeposit && p.type !== "refund" && (
                  <>
                    <Divider />
                    <InlineStack align="space-between">
                      <Text>Conciliado</Text>
                      <Text>{formatPrice(conciliado)}</Text>
                    </InlineStack>
                    <InlineStack align="space-between">
                      <Text>Disponible</Text>
                      {avail > 0.01 ? (
                        <Badge tone="attention">{formatPrice(avail)}</Badge>
                      ) : (
                        <Text tone="subdued">{formatPrice(0)}</Text>
                      )}
                    </InlineStack>
                    <Divider />
                    <Text variant="headingSm">Facturas</Text>
                    {paymentDetail.loading ? (
                      <Text tone="subdued">Cargando…</Text>
                    ) : paymentDetail.allocations.length === 0 ? (
                      <Text tone="subdued">Sin facturas asignadas.</Text>
                    ) : (
                      <BlockStack gap="150">
                        {paymentDetail.allocations.map((a) => (
                          <InlineStack key={a.id} align="space-between" blockAlign="center">
                            <InlineStack gap="150" blockAlign="center">
                              <Text>{a.invoice?.invoice_number || "—"}</Text>
                              {a.invoice?.payment_type === "PPD" &&
                                (a.rep_uuid ? (
                                  <Badge tone="success" size="small">Complemento ✓</Badge>
                                ) : (
                                  <Badge tone="critical" size="small">Sin complemento</Badge>
                                ))}
                            </InlineStack>
                            <Text>{formatPrice(a.amount)}</Text>
                          </InlineStack>
                        ))}
                      </BlockStack>
                    )}
                  </>
                )}
              </BlockStack>
            );
          })()}
        </Modal.Section>
      </Modal>
      <Modal
        open={applyCreditModal}
        onClose={() => setApplyCreditModal(false)}
        title="Traer crédito a esta reservación"
        primaryAction={{
          content: "Traer crédito",
          onAction: saveApplyCredit,
          loading: applyCreditSaving,
          disabled:
            !applyCreditAmount ||
            applyCreditSaving ||
            (parseFloat(applyCreditAmount) || 0) > externalCredit + 0.01 ||
            (parseFloat(applyCreditAmount) || 0) <= 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setApplyCreditModal(false) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <InlineGrid columns="1fr auto">
              <Text>Crédito disponible (perfil)</Text>
              <Text fontWeight="semibold" tone="success">{formatPrice(externalCredit)}</Text>
            </InlineGrid>
            <InlineGrid columns="1fr auto">
              <Text>Saldo de esta reservación</Text>
              <Text fontWeight="semibold">{formatPrice(Math.max(0, (resDetails.total_price || 0) - (resDetails.paid || 0)))}</Text>
            </InlineGrid>
            <TextField
              label="Monto a traer"
              value={applyCreditAmount}
              onChange={setApplyCreditAmount}
              type="number"
              prefix="$"
              max={String(externalCredit)}
              autoComplete="off"
            />
            <Text tone="subdued" variant="bodySm">
              El crédito se trae a esta reservación como un pago sin aplicar; concílialo a una factura desde Pagos. No es una nueva entrada de dinero al banco.
            </Text>
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={depositCreditModal}
        onClose={() => setDepositCreditModal(false)}
        title="Cobrar depósito con crédito"
        primaryAction={{
          content: "Cobrar depósito",
          onAction: saveDepositCredit,
          loading: depositCreditSaving,
          disabled:
            !depositCreditAmount ||
            depositCreditSaving ||
            (parseFloat(depositCreditAmount) || 0) > externalCredit + 0.01 ||
            (parseFloat(depositCreditAmount) || 0) <= 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setDepositCreditModal(false) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <InlineGrid columns="1fr auto">
              <Text>Crédito disponible (perfil)</Text>
              <Text fontWeight="semibold" tone="success">{formatPrice(externalCredit)}</Text>
            </InlineGrid>
            <InlineGrid columns="1fr auto">
              <Text>Depósito faltante</Text>
              <Text fontWeight="semibold">
                {formatPrice(Math.max(0, (resDetails.deposit || 0) - payments.filter((p) => p.isDeposit).reduce((s, p) => s + (p.amount || 0), 0)))}
              </Text>
            </InlineGrid>
            <TextField
              label="Monto a cobrar"
              value={depositCreditAmount}
              onChange={setDepositCreditAmount}
              type="number"
              prefix="$"
              max={String(externalCredit)}
              autoComplete="off"
            />
            <Text tone="subdued" variant="bodySm">
              Se registra como depósito (garantía) pagado desde el crédito del cliente. No es una nueva entrada de dinero al banco y no cuenta como pago de la renta.
            </Text>
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={creditModal}
        onClose={() => setCreditModal(false)}
        title="Mover excedente a crédito"
        primaryAction={{
          content: "Mover a crédito",
          onAction: saveMoveToCredit,
          loading: creditSaving,
          disabled: !creditAmount || creditSaving,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setCreditModal(false) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Text>
              Saldo a favor: {formatPrice(Math.abs(Math.min(0, (resDetails.total_price || 0) - (resDetails.paid || 0))))}
            </Text>
            <Text tone="subdued" variant="bodySm">
              El monto se moverá al crédito disponible del cliente y podrá
              aplicarse a otra factura. No sale dinero de la cuenta.
            </Text>
            <TextField
              label="Monto"
              value={creditAmount}
              onChange={setCreditAmount}
              type="number"
              prefix="$"
              autoComplete="off"
            />
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={refundModal}
        onClose={() => setRefundModal(false)}
        title="Reembolso"
        primaryAction={{
          content: "Aplicar Reembolso",
          onAction: saveRefund,
          loading: refundSaving,
          disabled: !refundAmount || !refundAccount || refundSaving,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setRefundModal(false) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Text>Saldo a favor: {formatPrice(Math.abs(Math.min(0, (resDetails.total_price || 0) - (resDetails.paid || 0))))}</Text>
            <TextField
              label="Monto a reembolsar"
              value={refundAmount}
              onChange={setRefundAmount}
              type="number"
              prefix="$"
              autoComplete="off"
            />
            {(() => {
              // Collapse bank accounts (Afirme, Base, etc.) into a single
              // "Transferencia SPEI" option — staff doesn't pick which bank.
              // Mirrors the deposit-return modal.
              // Fintoc (7) is excluded like it is in the deposit-return modal:
              // money only leaves Fintoc through pagos-svc, so booking a manual
              // refund against it would claim a transfer that nothing sent.
              // "Transferencia SPEI" therefore resolves to Afirme, exactly as
              // it did before Fintoc existed.
              const banks = refundAccounts.filter((a) => a.type === "bank" && a.id !== 7);
              const nonBanks = refundAccounts.filter((a) => a.type !== "bank");
              const selectedIsBank = banks.some(
                (b) => String(b.id) === refundAccount
              );
              const speiId = selectedIsBank
                ? refundAccount
                : banks[0]?.id;
              const options = [
                ...nonBanks.map((a) => ({ label: a.name, value: String(a.id) })),
                ...(banks.length > 0
                  ? [{ label: "Transferencia SPEI", value: String(speiId) }]
                  : []),
              ];
              return (
                <Select
                  label="Reembolsar mediante"
                  options={options}
                  value={refundAccount}
                  onChange={setRefundAccount}
                  helpText="Efectivo y tarjeta se marcan como reembolsados automáticamente; SPEI queda pendiente de transferir."
                />
              );
            })()}
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={discountModal}
        onClose={() => setDiscountModal(false)}
        title="Aplicar Descuento"
        primaryAction={{
          content: "Aplicar",
          onAction: saveDiscount,
          disabled:
            discountMode === "dias"
              ? !discountDays || parseInt(discountDays, 10) <= 0 || currentDailyRate <= 0
              : !discountAmount || parseFloat(discountAmount) <= 0,
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setDiscountModal(false) }]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Text>Total actual: {formatPrice(resDetails.total_price)}</Text>
            <Select
              label="Tipo de descuento"
              options={[
                { label: "Días (a tarifa actual)", value: "dias" },
                { label: "Monto fijo", value: "monto" },
              ]}
              value={discountMode}
              onChange={setDiscountMode}
            />
            {discountMode === "dias" ? (
              <>
                <TextField
                  label="Días de descuento"
                  value={discountDays}
                  onChange={setDiscountDays}
                  type="number"
                  min={1}
                  suffix={`× ${formatPrice(currentDailyRate)} / día`}
                  autoComplete="off"
                  helpText="Se congela la tarifa diaria actual: si la tarifa cambia después, el descuento no cambia."
                />
                {discountDays && parseInt(discountDays, 10) > 0 && (
                  <Text tone="success">
                    Descuento: {formatPrice((parseInt(discountDays, 10) || 0) * currentDailyRate)}
                    {" · "}Nuevo total: {formatPrice((resDetails.total_price || 0) - (parseInt(discountDays, 10) || 0) * currentDailyRate)}
                  </Text>
                )}
              </>
            ) : (
              <>
                <TextField
                  label="Monto del descuento"
                  value={discountAmount}
                  onChange={setDiscountAmount}
                  type="number"
                  prefix="$"
                  autoComplete="off"
                />
                {discountAmount && parseFloat(discountAmount) > 0 && (
                  <Text tone="success">Nuevo total: {formatPrice((resDetails.total_price || 0) - (parseFloat(discountAmount) || 0))}</Text>
                )}
              </>
            )}
            <TextField
              label="Motivo (interno, no aparece en factura)"
              value={discountReason}
              onChange={setDiscountReason}
              autoComplete="off"
            />
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={emailModal.open}
        onClose={() => setEmailModal({ ...emailModal, open: false })}
        title={`Enviar ${emailModal.invoiceNumber}`}
        primaryAction={emailSent ? {
          content: "Cerrar",
          onAction: () => setEmailModal({ ...emailModal, open: false }),
        } : {
          content: "Enviar",
          onAction: async () => {
            if (!emailTo) return;
            setEmailSending(true);
            try {
              await fetch("https://api.gomoverent.com/v2/alegra/proxy.php", {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: "Bearer h8ISmsSIwTvfl8Tny2nr0dFh2nz3rmiCzBMjtCJOJqn7TF6Y4wnch7uI1FI3ArlZP0wfMsGkEuqNXUzaX9wYSL5bnn9CzB1DkWAMFQVCBWBhRwAXn29M96YYxcp1bmfN" },
                body: JSON.stringify({ endpoint: `invoices/${emailModal.invoiceId}/email`, method: "POST", body: { emails: [emailTo], sendCopyToUser: false } }),
              });
              setEmailSent(true);
            } catch {}
            setEmailSending(false);
          },
          loading: emailSending,
          disabled: !emailTo || emailSending,
        }}
        secondaryActions={emailSent ? [] : [{ content: "Cancelar", onAction: () => setEmailModal({ ...emailModal, open: false }) }]}
      >
        <Modal.Section>
          {emailSent ? (
            <Banner tone="success">
              <p>Factura enviada a {emailTo}</p>
            </Banner>
          ) : (
            <BlockStack gap="200">
              <TextField
                label="Correo"
                value={emailTo}
                onChange={setEmailTo}
                type="email"
                placeholder="cliente@ejemplo.com"
                autoComplete="off"
              />
            </BlockStack>
          )}
        </Modal.Section>
      </Modal>
      <ChangeOwnerModal
        open={changeOwnerModal}
        onClose={() => setChangeOwnerModal(false)}
        reservationId={resDetails.id}
        currentOwnerId={resDetails.created_by}
        onSaved={refreshData}
      />
      <ChangeCarModal
        open={changeCarModal}
        onClose={() => setChangeCarModal(false)}
        dateRange={resDetails.date_range}
        currentCarId={resDetails.car?.id}
        branchId={resDetails.branch_id}
        onSelect={(newCarId, meta) => onCarSelected(newCarId, meta)}
        onSublease={openSubleaseChange}
        isCurrentlySublease={!!resDetails.is_sublease}
      />
      <Modal
        open={carChangeStep !== null}
        onClose={() => setCarChangeStep(null)}
        title="Confirmar Cambio de Auto"
        primaryAction={{
          content: "Confirmar Cambio",
          onAction: confirmCarChange,
          disabled: !carChangeReason.trim(),
        }}
        secondaryActions={[
          { content: "Cancelar", onAction: () => setCarChangeStep(null) },
          { content: "Elegir otro", onAction: () => { setCarChangeStep(null); setChangeCarModal(true); } },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <TextField
              label="Motivo del cambio"
              value={carChangeReason}
              onChange={setCarChangeReason}
              multiline={2}
              placeholder="Ej: Servicio programado, solicitud del cliente, upgrade..."
              requiredIndicator
            />
            <TextField
              label="Fecha del cambio"
              type="date"
              value={carChangeDate}
              onChange={setCarChangeDate}
            />
            <Text variant="bodySm" tone="subdued">
              La tarifa diaria se mantiene en {formatPrice(resDetails.totals?.dailyPrice || 0)}/día
            </Text>
          </BlockStack>
        </Modal.Section>
      </Modal>
      <Modal
        open={subleaseChangeModal}
        onClose={() => setSubleaseChangeModal(false)}
        title={resDetails.is_sublease ? "Editar Subarrendado" : "Cambiar a Subarrendado"}
        primaryAction={{
          content: "Confirmar",
          onAction: confirmSubleaseChange,
          disabled:
            !subleaseChangeData.model_id ||
            !subleaseChangeData.plate.trim() ||
            !subleaseChangeData.reason.trim(),
        }}
        secondaryActions={[{ content: "Cancelar", onAction: () => setSubleaseChangeModal(false) }]}
      >
        <Modal.Section>
          <FormLayout>
            <Select
              label="Modelo"
              value={subleaseChangeData.model_id}
              options={[
                { label: "Seleccionar un modelo", value: "" },
                ...carModelsList.map((m) => ({
                  label: `${m.brand?.name || ""} ${m.show_as || m.name}`.trim(),
                  value: String(m.id),
                })),
              ]}
              onChange={(val) => setSubleaseChangeData({ ...subleaseChangeData, model_id: val })}
              requiredIndicator
              helpText="Modelo más cercano de nuestro catálogo"
            />
            <FormLayout.Group>
              <TextField
                label="Placa"
                value={subleaseChangeData.plate}
                onChange={(val) => setSubleaseChangeData({ ...subleaseChangeData, plate: val.toUpperCase() })}
                autoComplete="off"
                requiredIndicator
              />
              <TextField
                label="VIN (opcional)"
                value={subleaseChangeData.vin}
                onChange={(val) => setSubleaseChangeData({ ...subleaseChangeData, vin: val.toUpperCase() })}
                autoComplete="off"
              />
            </FormLayout.Group>
            <TextField
              label="Motivo del cambio"
              value={subleaseChangeData.reason}
              onChange={(val) => setSubleaseChangeData({ ...subleaseChangeData, reason: val })}
              multiline={2}
              placeholder="Ej: Auto en servicio, solicitud del cliente..."
              requiredIndicator
            />
            <TextField
              label="Fecha del cambio"
              type="date"
              value={subleaseChangeData.date}
              onChange={(val) => setSubleaseChangeData({ ...subleaseChangeData, date: val })}
            />
            <Text variant="bodySm" tone="subdued">
              La tarifa diaria ({formatPrice(resDetails.totals?.dailyPrice || 0)}/día) y el total se mantienen. Ajusta manualmente si el subarrendado tiene otro costo.
            </Text>
          </FormLayout>
        </Modal.Section>
      </Modal>
      <PopUpSearch
        activated={additionalDriverModal}
        setOpen={setAdditionalDriverModal}
        getCustomer={({ id }) => addAdditionalDriver({ id })}
        title="Agregar Conductor"
        dbFunction="search_customers"
      />
      <PopUpSearch
        activated={customerModal}
        setOpen={setCustomerModal}
        getCustomer={({ id, name }) => {
          changeCustomer({ id });
          setCustomerModal(false);
        }}
        title="Clientes"
        dbFunction="search_customers"
      />
      <PopUpSearch
        activated={companyModal}
        setOpen={setCompanyModal}
        getCustomer={({ id, name }) => {
          changeCompany({ id });
          setCompanyModal(false);
        }}
        title="Empresas"
        dbFunction="search_company"
      />
      <Modal
        open={cancelModal}
        onClose={() => setCancelModal(false)}
        title="Cancelar Reservación"
        primaryAction={{
          content: "Cancelar Reservación",
          destructive: true,
          onAction: cancelReservation,
          disabled: !cancelReason.trim(),
        }}
        secondaryActions={[
          { content: "Volver", onAction: () => setCancelModal(false) },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="300">
            <Text>¿Estás seguro de que deseas cancelar esta reservación?</Text>
            <TextField
              label="Motivo de Cancelación"
              value={cancelReason}
              onChange={setCancelReason}
              multiline={2}
              requiredIndicator
              placeholder="Ej: Cliente cancela, cambio de planes..."
            />
          </BlockStack>
        </Modal.Section>
      </Modal>
      <PopUpAmount
        title={editTotal.title}
        activated={editTotal.activated}
        ogValue={editTotal.value}
        passInfo={({ activated, key, value, title }) => {
          setEditTotal({ activated, key, value, title });
        }}
        save={saveEditTotal}
      />
      {resDetails.id != undefined ? (
        <Page
          backAction={{ url: "/reservations" }}
          title={`Reservacion #${reservationId}`}
          titleMetadata={
            <>
              {resDetails.type === "service" && (
                <Badge tone="warning">Servicio</Badge>
              )}{" "}
              {resDetails.status === "cancelled" ? (
                <Badge tone="critical">Cancelada</Badge>
              ) : resDetails.status === "no_show" ? (
                <Badge tone="warning">No-Show</Badge>
              ) : resDetails.status === "completed" ? (
                <Badge>Completada</Badge>
              ) : resDetails.status === "quotation" ? (
                <Badge tone="info">Cotización</Badge>
              ) : resDetails.checked_out && !resDetails.checked_in ? (
                <Badge tone="success">Entregado</Badge>
              ) : resDetails.checked_out && resDetails.checked_in ? (
                <Badge>Devuelto</Badge>
              ) : resDetails.fully_paid ? (
                <Badge tone="success">Pagada</Badge>
              ) : (
                <Badge tone="attention">Reservado</Badge>
              )}
              {resDetails.possible_extension && resDetails.status === "active" && (
                <>
                  {" "}
                  <Badge tone="info">Posible extensión</Badge>
                </>
              )}
            </>
          }
          subtitle={`${resDetails.rent_time.days} dias${
            resDetails.rent_time.hours === 0
              ? ""
              : " y " + resDetails.rent_time.hours + " horas"
          }${
            resDetails.created_by_user?.name
              ? ` | ${resDetails.created_by_user.name}`
              : ""
          }`}
          actionGroups={
            isCancelled || resDetails.status === "no_show"
              ? []
              : pageActionGroups
          }
          secondaryActions={
            isCancelled || resDetails.status === "no_show"
              ? [
                  { content: "Reactivar", onAction: reactivateReservation },
                  ...changeOwnerAction,
                  // A reservation cancelled before pickup never gets checked in,
                  // so the deposit return (gated on check-in in the normal menu)
                  // would be unreachable. Surface it here too when there's still
                  // a deposit to give back.
                  ...(!resDetails.deposit_returned && depositPaid > 0 && !clipRefundPending
                    ? [{ content: depositActionLabel, onAction: openDepositReturn }]
                    : []),
                ]
              : []
          }
        >
          <Layout>
            {isWrittenOff && (
              <Layout.Section>
                <Banner tone="warning" title="Cobranza por fuera">
                  <BlockStack gap="100">
                    {resDetails.written_off_notes && (
                      <Text>{resDetails.written_off_notes}</Text>
                    )}
                    <Text>
                      Este saldo se gestiona por fuera del proceso normal: no
                      aparece en Saldo a Hoy, sino en el reporte de Cuentas
                      Incobrables. La deuda sigue vigente.
                    </Text>
                    <Text variant="bodySm" tone="subdued">
                      Separado el {formatFriendlyDate(resDetails.written_off_at)}
                    </Text>
                  </BlockStack>
                </Banner>
              </Layout.Section>
            )}
            <Layout.Section variant="twoThirds">
              <BlockStack gap={400}>
                <Card>
                  <InlineGrid columns="1fr auto">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <Text variant="headingMd">Vehiculo</Text>
                      {resDetails.is_sublease && <Badge tone="info">Subarrendado</Badge>}
                      {resDetails.insurance === "none" && <Badge tone="critical">Sin Seguro</Badge>}
                    </div>

                    <Button onClick={() => setChangeCarModal(true)} icon={ExchangeIcon} disabled={isCancelled}>
                      Cambiar Auto
                    </Button>
                  </InlineGrid>

                  {resDetails.is_sublease ? (
                    <div style={{ padding: "12px 0" }}>
                      <Text variant="headingMd">
                        {resDetails.sublease_model?.brand?.name}{" "}
                        {resDetails.sublease_model?.show_as || resDetails.sublease_model?.name}
                      </Text>
                      <Text variant="headingLg">{resDetails.sublease_plate}</Text>
                      {resDetails.sublease_vin && (
                        <Text variant="bodySm" tone="subdued">VIN: {resDetails.sublease_vin}</Text>
                      )}
                    </div>
                  ) : (
                  <InlineGrid columns={["oneThird", "twoThirds"]}>
                    <img
                      src={resDetails.car.model.image_url}
                      style={{ width: "100%" }}
                    />
                    <div style={{ alignContent: "center" }}>
                      <Text variant="headingMd">
                        {resDetails.car.model.brand.name}{" "}
                        {resDetails.car.model.show_as ||
                          resDetails.car.model.name}
                      </Text>
                      <Text variant="headingLg">{formatPlate(resDetails.car.plate)}</Text>
                      <Text variant="headingMd">
                        {resDetails.car.color} {resDetails.car.year}
                      </Text>
                      <div>
                        <Chip
                          variant="outlined"
                          size="small"
                          icon={<PersonIcon />}
                          label={`${resDetails.car.model.passengers}p`}
                          className="detail_chip"
                        />
                        <Chip
                          variant="outlined"
                          size="small"
                          icon={<DeviceHubIcon />}
                          label={`${resDetails.car.model.transmission.substring(
                            0,
                            3
                          )}`}
                          className="detail_chip"
                        />
                        {!resDetails.car.model.weight_capacity || (
                          <>
                            <Chip
                              variant="outlined"
                              size="small"
                              icon={<FrontLoaderIcon />}
                              label={`${resDetails.car.model.weight_capacity}kg`}
                              className="detail_chip"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </InlineGrid>
                  )}
                  {carHistory.length > 0 && (
                    <>
                      <Divider />
                      <BlockStack gap="200">
                        <Text variant="headingSm" tone="subdued">Historial de autos</Text>
                        {carHistory.map((ch) => (
                          <div key={ch.id} style={{ borderLeft: "3px solid #e0e0e0", paddingLeft: "8px", marginBottom: "4px" }}>
                            <Text variant="bodySm" fontWeight="semibold">
                              {ch.prev_model} ({ch.prev_plate}) → {ch.new_model} ({ch.new_plate})
                            </Text>
                            <Text variant="bodySm" tone="subdued">
                              {ch.changed_at ? formatDate(ch.changed_at.substring(0, 10)) : ""} · {ch.reason || "Sin motivo"}
                            </Text>
                          </div>
                        ))}
                      </BlockStack>
                    </>
                  )}
                </Card>
                {inspectionsSection()}
                <Card>
                  <InlineGrid columns="1fr auto auto" gap={100}>
                    <Text variant="headingMd">Cliente</Text>
                    {resDetails.company ? (
                      <Button onClick={() => setCompanyModal(true)} icon={ExchangeIcon} disabled={isCancelled}>
                        Cambiar Empresa
                      </Button>
                    ) : (
                      <Button onClick={() => setCompanyModal(true)} icon={LinkIcon} disabled={isCancelled}>
                        Ligar Empresa
                      </Button>
                    )}

                    <Button onClick={() => setCustomerModal(true)} icon={ExchangeIcon} disabled={isCancelled}>
                      Cambiar Cliente
                    </Button>
                  </InlineGrid>
                  <br />
                  <InlineGrid columns={resDetails.company ? 2 : 1}>
                    {resDetails.company ? (
                      <>
                        {companySection()}
                        {customerSection()}
                      </>
                    ) : (
                      <>{customerSection()}</>
                    )}
                  </InlineGrid>
                  {resDetails.type === "rental" && (
                    <>
                      <Divider />
                      <InlineGrid columns="1fr auto">
                        <Text variant="headingSm">Conductores Adicionales</Text>
                        <Button
                          size="slim"
                          onClick={() => setAdditionalDriverModal(true)}
                          disabled={isCancelled}
                        >
                          Agregar
                        </Button>
                      </InlineGrid>
                      {additionalDrivers.length > 0 ? (
                        <BlockStack gap="100">
                          {additionalDrivers.map((d) => (
                            <InlineGrid key={d.id} columns="1fr auto">
                              <Text variant="bodySm">
                                {d.first_name} {d.last_name}
                              </Text>
                              {!isCancelled && (
                                <Button
                                  variant="plain"
                                  tone="critical"
                                  onClick={() => removeAdditionalDriver(d.id)}
                                >
                                  ×
                                </Button>
                              )}
                            </InlineGrid>
                          ))}
                        </BlockStack>
                      ) : (
                        <Text variant="bodySm" tone="subdued">
                          Sin conductores adicionales
                        </Text>
                      )}
                    </>
                  )}
                </Card>
                <Card>
                  <InlineGrid columns="1fr auto" gap={100}>
                    <Text variant="headingMd">Entrega y Devolución</Text>
                    <Button onClick={openDeliveryEdit} disabled={isCancelled}>
                      {resDetails.delivery ? "Editar" : "Agregar"}
                    </Button>
                  </InlineGrid>
                  <br />
                  {resDetails.delivery ? (
                    <InlineGrid columns={2} gap="300">
                      <BlockStack gap="100">
                        <Text variant="headingSm">Entrega</Text>
                        {resDetails.delivery.type === "domicilio" ? (
                          <Badge tone="info">A Domicilio</Badge>
                        ) : (
                          <Badge>En Sucursal</Badge>
                        )}
                        <Text>{resDetails.delivery.address || "-"}</Text>
                        {resDetails.delivery.notes && (
                          <Text tone="subdued">{resDetails.delivery.notes}</Text>
                        )}
                      </BlockStack>
                      <BlockStack gap="100">
                        <Text variant="headingSm">Devolución</Text>
                        {resDetails.return?.type === "domicilio" ? (
                          <Badge tone="info">A Domicilio</Badge>
                        ) : (
                          <Badge>En Sucursal</Badge>
                        )}
                        <Text>{resDetails.return?.address || "-"}</Text>
                        {resDetails.return?.notes && (
                          <Text tone="subdued">{resDetails.return.notes}</Text>
                        )}
                      </BlockStack>
                    </InlineGrid>
                  ) : (
                    <Text tone="subdued">El cliente recoge y entrega en sucursal Colón</Text>
                  )}
                </Card>
              </BlockStack>
            </Layout.Section>
            <Layout.Section variant="oneThird">
              <BlockStack gap={400}>
                {/* The CLABE this reservation should be paid into. Belongs to
                    the BILLING ENTITY — the company when there is one, since on
                    a company lease the person is the driver and the company
                    pays. Paying into the driver's CLABE would credit the wrong
                    party. */}
                {(resDetails.company?.id || resDetails.customer?.id) && (
                  <Card>
                    <PaymentClabe
                      compact
                      ownerType={resDetails.company?.id ? "company" : "customer"}
                      ownerId={resDetails.company?.id || resDetails.customer?.id}
                      ownerName={
                        resDetails.company?.id
                          ? resDetails.company?.name
                          : `${resDetails.customer?.first_name || ""} ${
                              resDetails.customer?.last_name || ""
                            }`.trim()
                      }
                    />
                  </Card>
                )}
                {clientBenefits.length > 0 && (
                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingSm">Beneficios</Text>
                      <InlineStack gap="150" wrap>
                        {clientBenefits.map((b, i) => (
                          <Badge
                            key={i}
                            tone={
                              ["success", "info", "attention", "warning", "critical"].includes(b.tone)
                                ? b.tone
                                : "info"
                            }
                          >
                            {b.name}
                          </Badge>
                        ))}
                      </InlineStack>
                    </BlockStack>
                  </Card>
                )}
                {otherDebt.items.length > 0 && (
                  <Card>
                    <BlockStack gap="200">
                      <InlineGrid columns="1fr auto" gap="200">
                        <Text variant="headingSm" tone="critical">
                          Adeudo de otras reservaciones
                        </Text>
                        <Text variant="headingMd" tone="critical">
                          {formatPrice(otherDebt.total)}
                        </Text>
                      </InlineGrid>
                      <Button
                        variant="plain"
                        disclosure={otherDebtOpen ? "up" : "down"}
                        onClick={() => setOtherDebtOpen((o) => !o)}
                      >
                        {otherDebtOpen
                          ? "Ocultar detalle"
                          : `Ver detalle (${otherDebt.items.length})`}
                      </Button>
                      {otherDebtOpen && (
                        <BlockStack gap="150">
                          {otherDebt.items.map((it) => (
                            <InlineGrid key={it.id} columns="1fr auto" gap="200">
                              <Button
                                variant="plain"
                                url={`/reservation?id=${it.id}`}
                              >
                                Reservación #{it.id}
                              </Button>
                              <Text tone="critical">{formatPrice(it.balance)}</Text>
                            </InlineGrid>
                          ))}
                        </BlockStack>
                      )}
                    </BlockStack>
                  </Card>
                )}
                {externalCredit > 0.005 && (() => {
                  const owed = Math.max(0, (resDetails.total_price || 0) - (resDetails.paid || 0));
                  const depositPaid = payments
                    .filter((p) => p.isDeposit)
                    .reduce((sum, p) => sum + (p.amount || 0), 0);
                  const depositMissing = resDetails.deposit_returned
                    ? 0
                    : Math.max(0, (resDetails.deposit || 0) - depositPaid);
                  return (
                    <Card>
                      <BlockStack gap="200">
                        <InlineStack align="space-between" blockAlign="center">
                          <Text variant="headingSm">Crédito disponible (perfil)</Text>
                          <Text variant="headingMd" tone="success">{formatPrice(externalCredit)}</Text>
                        </InlineStack>
                        {owed > 0.005 ? (
                          <Text variant="bodySm">
                            Esta reservación tiene <strong>{formatPrice(owed)}</strong> por cobrar.
                            Puedes cubrirlo con el crédito del cliente (total o parcial).
                          </Text>
                        ) : depositMissing > 0.005 ? (
                          <Text variant="bodySm">
                            Falta <strong>{formatPrice(depositMissing)}</strong> de garantía.
                            Puedes cubrirlo con el crédito del cliente.
                          </Text>
                        ) : (
                          <Text tone="subdued" variant="bodySm">
                            Crédito del cliente que puedes traer a esta reservación.
                          </Text>
                        )}
                        {owed > 0.005 && (
                          <Button variant="primary" onClick={openApplyCreditModal}>
                            Aplicar a renta
                          </Button>
                        )}
                        {depositMissing > 0.005 && (
                          <Button
                            variant={owed > 0.005 ? undefined : "primary"}
                            onClick={openDepositCreditModal}
                          >
                            Aplicar a garantía
                          </Button>
                        )}
                        {owed <= 0.005 && depositMissing <= 0.005 && (
                          <Button onClick={openApplyCreditModal}>
                            Traer a esta reservación
                          </Button>
                        )}
                      </BlockStack>
                    </Card>
                  );
                })()}
                <Card>
                  <Text variant="headingMd">Resumen</Text>
                  {(() => {
                    const clean = (resDetails.date_range || "").replace(/[\[\]()]/g, "");
                    const parts = clean.split(",");
                    const startStr = parts[0]?.replace(/"/g, "").trim() || "";
                    const endStr = parts[1]?.replace(/"/g, "").trim() || "";
                    const hasEnd = endStr && endStr !== "" && endStr !== "infinity";
                    const startDate = startStr.substring(0, 10);
                    const startTime = startStr.substring(11, 16);
                    const endDate = hasEnd ? endStr.substring(0, 10) : "";
                    const endTime = hasEnd ? endStr.substring(11, 16) : "";
                    return (
                      <>
                        <InlineGrid columns="1fr auto">
                          <Text variant="bodyMd">Entrega</Text>
                          {!resDetails.checked_out && !isCancelled ? (
                            <Button variant="plain" onClick={() => setDateEditModal({ open: true, type: "entrega", date: startDate, hour: startTime })}>
                              {formatDate(startDate)} {startTime}
                            </Button>
                          ) : (
                            <Text variant="bodyMd" tone="subdued">{formatDate(startDate)} {startTime}</Text>
                          )}
                        </InlineGrid>
                        {hasEnd ? (
                          <InlineGrid columns="1fr auto">
                            <Text variant="bodyMd">Devolución</Text>
                            {!resDetails.checked_in && !isCancelled ? (
                              <Button variant="plain" onClick={() => setDateEditModal({ open: true, type: "devolucion", date: endDate, hour: endTime })}>
                                {formatDate(endDate)} {endTime}
                              </Button>
                            ) : (
                              <Text variant="bodyMd" tone="subdued">{formatDate(endDate)} {endTime}</Text>
                            )}
                          </InlineGrid>
                        ) : (
                          <InlineGrid columns="1fr auto">
                            <Text variant="bodyMd">Devolución</Text>
                            <Text variant="bodyMd" tone="subdued">Indefinido</Text>
                          </InlineGrid>
                        )}
                      </>
                    );
                  })()}
                  <br />
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd">Seguro</Text>
                    <Tooltip content={insuranceTexts[resDetails.insurance] || ""}>
                      <Text
                        variant="bodyMd"
                        tone={!resDetails.insurance || resDetails.insurance === "none" ? "critical" : undefined}
                      >
                        {insuranceLabels[resDetails.insurance] || resDetails.insurance || "Sin Seguro"}
                      </Text>
                    </Tooltip>
                  </InlineGrid>
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd">Tarifa Diaria</Text>
                    <Button
                      variant="plain"
                      onClick={() => !isCancelled && openChangeRateModal()}
                    >
                      {formatPrice(resDetails.totals.dailyPrice)}
                    </Button>
                  </InlineGrid>
                  {!resDetails.totals.hoursExtra || (
                    <InlineGrid columns="1fr auto">
                      <Text variant="bodyMd">Horas Extra</Text>
                      <Button
                        variant="plain"
                        onClick={() =>
                          !isCancelled && setEditTotal({
                            activated: true,
                            key: "hoursExtra",
                            value: resDetails.totals.hoursExtra,
                            title: "Horas Extra",
                          })
                        }
                      >
                        {formatPrice(resDetails.totals.hoursExtra)}
                      </Button>
                    </InlineGrid>
                  )}
                  {resDetails.delivery?.fee > 0 && (
                    <InlineGrid columns="1fr auto">
                      <Text variant="bodyMd">Entrega a domicilio</Text>
                      <Text variant="bodyMd">{formatPrice(resDetails.delivery.fee)}</Text>
                    </InlineGrid>
                  )}
                  {resDetails.return?.fee > 0 && (
                    <InlineGrid columns="1fr auto">
                      <Text variant="bodyMd">Recolección</Text>
                      <Text variant="bodyMd">{formatPrice(resDetails.return.fee)}</Text>
                    </InlineGrid>
                  )}
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd" tone="bold">
                      Total
                    </Text>
                    <Text variant="bodyMd" fontWeight="bold">
                      {formatPrice(resDetails.total_price)}
                    </Text>
                  </InlineGrid>
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd">Depósito</Text>
                    <Button
                      variant="plain"
                      onClick={() =>
                        !isCancelled && setEditTotal({
                          activated: true,
                          key: "deposit",
                          value: resDetails.totals.deposit,
                          title: "Depósito",
                        })
                      }
                    >
                      {formatPrice(resDetails.totals.deposit)}
                    </Button>
                  </InlineGrid>
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd">Total (Renta + Depósito)</Text>
                    <Text variant="bodyMd" tone="subdued">
                      {formatPrice(
                        resDetails.totals.deposit + resDetails.total_price
                      )}
                    </Text>
                  </InlineGrid>
                  <Divider />
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd">Pagado</Text>
                    <Text variant="bodyMd" tone="success">
                      {formatPrice(resDetails.paid || 0)}
                    </Text>
                  </InlineGrid>
                  <InlineGrid columns="1fr auto">
                    <Text variant="bodyMd" fontWeight="bold">
                      {(resDetails.total_price - (resDetails.paid || 0)) <= 0 ? "Saldo a favor" : "Por cobrar"}
                    </Text>
                    <Text
                      variant="bodyMd"
                      fontWeight="bold"
                      tone={(resDetails.total_price - (resDetails.paid || 0)) <= 0 ? "success" : "critical"}
                    >
                      {formatPrice(Math.abs(resDetails.total_price - (resDetails.paid || 0)))}
                    </Text>
                  </InlineGrid>
                  {resDetails.fully_paid && (
                    <Badge tone="success">Pagado completo</Badge>
                  )}
                </Card>
                {pricePeriods.length > 0 && (
                  <Card>
                    <Text variant="headingMd">Historial de Tarifa</Text>
                    <BlockStack gap="200">
                      {pricePeriods.map((p) => {
                        const isOpen = p.effective_to == null;
                        const rangeLabel = isOpen
                          ? `${formatDate(p.effective_from)} → vigente`
                          : `${formatDate(p.effective_from)} → ${formatDate(p.effective_to)}`;
                        return (
                          <div key={p.id} style={{ paddingTop: 8 }}>
                            <InlineGrid columns="1fr auto">
                              <Text variant="bodyMd" fontWeight={isOpen ? "semibold" : "regular"}>
                                {formatPrice(p.daily_price)}/día
                              </Text>
                              {isOpen && <Badge tone="info">Vigente</Badge>}
                            </InlineGrid>
                            <Text variant="bodySm" tone="subdued">{rangeLabel}</Text>
                            {p.reason && (
                              <Text variant="bodySm" tone="subdued">{p.reason}</Text>
                            )}
                          </div>
                        );
                      })}
                    </BlockStack>
                  </Card>
                )}
                <UnappliedPaymentsCard
                  reservationId={resDetails.id}
                  customerId={resDetails.customer?.id}
                  customerName={[resDetails.customer?.first_name, resDetails.customer?.last_name]
                    .filter(Boolean).join(" ").replace(/\s+/g, " ")}
                  companyId={resDetails.company?.id}
                  companyName={resDetails.company?.name}
                  onApplied={refreshData}
                />
                <Card>
                  <Text variant="headingMd">Pagos</Text>
                  <ResourceList
                    items={[...payments, ...indirectPayments]}
                    renderItem={(item) => {
                      const {
                        id,
                        created_at,
                        payment_date,
                        type,
                        amount,
                        isDeposit,
                        account,
                        invoiced,
                        unallocated_amount,
                      } = item;

                      // Client-level payment reaching this reservation via one of
                      // its invoices. Show what it applied HERE, not its face
                      // value, and no "Sin facturar" badge — any remaining credit
                      // belongs to the client, not to this reservation.
                      if (item.__indirect) {
                        return (
                          <ResourceItem id={id} onClick={() => openPaymentDetail(item)}>
                            <InlineGrid columns="1fr auto">
                              <div style={{ display: "flex", marginRight: "auto", gap: "4px" }}>
                                <Icon source={IncomingIcon} tone="success" />
                                <div>
                                  <Text variant="bodySm">
                                    {formatDate(payment_date || created_at?.substring(0, 10))}
                                  </Text>
                                  <Text tone="subdued">
                                    Pago a nivel cliente · {account?.name || "—"}
                                  </Text>
                                  <Text variant="bodySm" tone="subdued">
                                    Aplicado a {[...item.invoiceNumbers].join(", ")}
                                  </Text>
                                </div>
                              </div>
                              <div style={{ textAlign: "right" }}>
                                <Text variant="bodySm">{formatPrice(item.appliedHere)}</Text>
                                <Badge tone="info" size="small">Nivel cliente</Badge>
                              </div>
                            </InlineGrid>
                          </ResourceItem>
                        );
                      }

                      return (
                        <ResourceItem id={id} onClick={() => openPaymentDetail(item)}>
                          <InlineGrid
                            columns="1fr auto"
                            color="--p-color-text-success"
                          >
                            <div
                              style={{
                                display: "flex",
                                marginRight: "auto",
                                gap: "4px",
                              }}
                            >
                              {type === "income" ? (
                                <Icon source={IncomingIcon} tone="success" />
                              ) : (
                                <Icon source={OutgoingIcon} tone="critical" />
                              )}
                              <div>
                                <Text variant="bodySm">
                                  {formatDate(payment_date || created_at?.substring(0, 10))}
                                </Text>
                                <Text tone="subdued">
                                  {type === "refund" ? "Reembolso" : isDeposit ? "Depósito" : "Pago"}{" "}
                                  {account.name}
                                </Text>
                              </div>
                            </div>

                            <div style={{ textAlign: "right" }}>
                              <Text variant="bodySm" tone={type === "refund" ? "critical" : undefined}>{type === "refund" ? "-" : ""}{formatPrice(amount)}</Text>
                              {!isDeposit && (() => {
                                // What's still available to apply. Drive the badge
                                // off the residual amount, not the `invoiced`
                                // boolean: a partially-conciliated payment is
                                // `invoiced=true` yet still has credit to apply,
                                // and keying off the flag hid that remainder.
                                const avail =
                                  unallocated_amount ?? (invoiced ? 0 : amount);
                                if (avail <= 0.01) return null;
                                const partial = avail < amount - 0.01;
                                return (
                                  <div style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); openConcilFromPayment({ id, amount, unallocated_amount: avail }); }}>
                                    <Badge tone={partial ? "attention" : "critical"} size="small">
                                      {partial ? `Falta ${formatPrice(avail)}` : "Sin facturar"}
                                    </Badge>
                                  </div>
                                );
                              })()}
                            </div>
                          </InlineGrid>
                        </ResourceItem>
                      );
                    }}
                  ></ResourceList>
                </Card>
                {charges.length > 0 && (
                  <Card>
                    <Text variant="headingMd">Cargos Extra</Text>
                    <BlockStack gap="200">
                      {charges.map((charge) => (
                        <InlineGrid key={charge.id} columns="1fr auto auto" gap="100">
                          <BlockStack gap="050">
                            <Text variant="bodySm">{charge.description}</Text>
                            <Text variant="bodySm" tone="subdued">
                              {{
                                damage: "Daño",
                                fuel: "Combustible",
                                cleaning: "Limpieza profunda",
                                fine: "Multa",
                                toll: "Peaje",
                                other: "Otro",
                              }[charge.charge_type]}
                            </Text>
                          </BlockStack>
                          <Text variant="bodySm" tone="critical">
                            {formatPrice(charge.amount)}
                          </Text>
                          {!isCancelled && (
                            <Button
                              variant="plain"
                              tone="critical"
                              onClick={() => deleteCharge(charge.id)}
                            >
                              ×
                            </Button>
                          )}
                        </InlineGrid>
                      ))}
                      <Divider />
                      <InlineGrid columns="1fr auto">
                        <Text variant="bodySm" fontWeight="bold">Total Cargos</Text>
                        <Text variant="bodySm" fontWeight="bold" tone="critical">
                          {formatPrice(charges.reduce((sum, c) => sum + c.amount, 0))}
                        </Text>
                      </InlineGrid>
                    </BlockStack>
                  </Card>
                )}
                {discounts.length > 0 && (
                  <Card>
                    <Text variant="headingMd">Descuentos</Text>
                    <BlockStack gap="200">
                      {discounts.map((disc) => (
                        <InlineGrid key={disc.id} columns="1fr auto auto" gap="100">
                          <BlockStack gap="050">
                            <Text variant="bodySm">
                              {disc.reason || "Descuento"}
                              {disc.days
                                ? ` · ${disc.days} día${disc.days === 1 ? "" : "s"} @ ${formatPrice(disc.daily_price || 0)}`
                                : ""}
                            </Text>
                            <Text variant="bodySm" tone="subdued">
                              {formatDate(disc.created_at?.substring(0, 10))}
                            </Text>
                          </BlockStack>
                          <Text variant="bodySm" tone="success">
                            -{formatPrice(disc.amount)}
                          </Text>
                          {!isCancelled && (
                            <Button
                              variant="plain"
                              tone="critical"
                              onClick={() => deleteDiscount(disc.id)}
                            >
                              ×
                            </Button>
                          )}
                        </InlineGrid>
                      ))}
                      <Divider />
                      <InlineGrid columns="1fr auto">
                        <Text variant="bodySm" fontWeight="bold">Total Descuentos</Text>
                        <Text variant="bodySm" fontWeight="bold" tone="success">
                          -{formatPrice(discounts.reduce((sum, d) => sum + d.amount, 0))}
                        </Text>
                      </InlineGrid>
                    </BlockStack>
                  </Card>
                )}
                {resDetails.deposit > 0 && (() => {
                  const depositPayments = payments.filter(p => p.isDeposit);
                  const depositPaid = depositPayments.reduce((sum, p) => sum + p.amount, 0);
                  const depositCollected = depositPaid >= resDetails.deposit;

                  return (
                    <Card>
                      <InlineGrid columns="1fr auto">
                        <Text variant="headingMd">Depósito</Text>
                        {resDetails.deposit_returned ? (
                          <Badge tone="success">Devuelto</Badge>
                        ) : depositCollected ? (
                          <Badge tone="info">Cobrado</Badge>
                        ) : depositPaid > 0 ? (
                          <Badge tone="warning">Parcial</Badge>
                        ) : (
                          <Badge tone="critical">No cobrado</Badge>
                        )}
                      </InlineGrid>
                      <InlineGrid columns="1fr auto">
                        <Text variant="bodySm" tone="subdued">Requerido</Text>
                        <Text variant="bodySm">{formatPrice(resDetails.deposit)}</Text>
                      </InlineGrid>
                      {depositPaid > 0 && (
                        <InlineGrid columns="1fr auto">
                          <Text variant="bodySm" tone="subdued">
                            Cobrado{depositPayments.length > 0 &&
                              ` ${formatDate(depositPayments[depositPayments.length - 1].created_at?.substring(0, 10))}`}
                          </Text>
                          <Text variant="bodySm" tone="success">{formatPrice(depositPaid)}</Text>
                        </InlineGrid>
                      )}
                      {!depositCollected && !resDetails.deposit_returned && (
                        <InlineGrid columns="1fr auto">
                          <Text variant="bodySm" tone="subdued">Faltante</Text>
                          <Text variant="bodySm" tone="critical">{formatPrice(resDetails.deposit - depositPaid)}</Text>
                        </InlineGrid>
                      )}
                      {resDetails.deposit_returned && resDetails.deposit_amount_returned != null && resDetails.deposit_amount_returned < depositPaid && (
                        <>
                          <Divider />
                          <InlineGrid columns="1fr auto">
                            <Text variant="bodySm" tone="subdued">Deducciones</Text>
                            <Text variant="bodySm" tone="critical">-{formatPrice(depositPaid - resDetails.deposit_amount_returned)}</Text>
                          </InlineGrid>
                          <InlineGrid columns="1fr auto">
                            <Text variant="bodySm" fontWeight="bold" tone="success">Devuelto</Text>
                            <Text variant="bodySm" fontWeight="bold" tone="success">{formatPrice(resDetails.deposit_amount_returned)}</Text>
                          </InlineGrid>
                        </>
                      )}
                      {clipRefund && ["queued", "awaiting_funds", "unknown", "succeeded"].includes(clipRefund.status) && (
                        <>
                          <Divider />
                          <ClipRefundStatus
                            refund={clipRefund}
                            canResolve={hasPermission("services.pay")}
                            onChanged={() => { setClipRefundTick((t) => t + 1); refreshData(); }}
                          />
                        </>
                      )}
                      {cardPayout && !["succeeded", "canceled"].includes(cardPayout.status) && (
                        <>
                          <Divider />
                          <CardReturnStatus payout={cardPayout} />
                        </>
                      )}
                      {returnPayout && (
                        <>
                          <Divider />
                          <InlineGrid columns="1fr auto" alignItems="center">
                            <Text variant="bodySm" tone="subdued">
                              Devuelto {formatDate(returnPayout.resolved_at?.substring(0, 10))}
                            </Text>
                            <Button
                              variant="plain"
                              icon={PageDownIcon}
                              loading={loadingReceipt}
                              onClick={openReturnReceipt}
                              accessibilityLabel="Descargar comprobante de la devolución"
                            />
                          </InlineGrid>
                        </>
                      )}
                    </Card>
                  );
                })()}
                {/* Invoices */}
                {issuedInvoices.length > 0 && (
                  <Card>
                    <BlockStack gap="300">
                      <Text variant="headingMd">Facturas</Text>
                      {issuedInvoices.map((inv) => {
                        const paid = (inv.amount_paid || 0) + (inv.amount_credited || 0);
                        const due = invoiceDue(inv);
                        return (
                          <div
                            key={inv.id}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setInvoiceActions({ open: true, invoice: inv })
                            }
                          >
                            <InlineGrid columns="1fr auto">
                              <BlockStack gap="050">
                                <InlineStack gap="100" blockAlign="center">
                                  <Text
                                    variant="bodySm"
                                    fontWeight="semibold"
                                    textDecorationLine={inv.status === "void" ? "line-through" : undefined}
                                  >
                                    {inv.invoice_number || `#${inv.alegra_id}`}
                                  </Text>
                                  {inv.stamped && (
                                    <Badge tone="info" size="small">CFDI</Badge>
                                  )}
                                </InlineStack>
                                <Text
                                  variant="bodySm"
                                  tone="subdued"
                                  textDecorationLine={inv.status === "void" ? "line-through" : undefined}
                                >
                                  {formatDate(inv.date)} · {formatPrice(inv.total)}
                                  {inv.amount_credited > 0.01 ? ` · NC ${formatPrice(inv.amount_credited)}` : ""}
                                </Text>
                              </BlockStack>
                              {inv.status === "void" ? (
                                <Badge tone="critical" size="small">Cancelada</Badge>
                              ) : due <= 0.01 ? (
                                <Badge tone="success" size="small">Pagada</Badge>
                              ) : paid > 0 ? (
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => { e.stopPropagation(); openConcilFromInvoice(inv); }}
                                >
                                  <Badge tone="attention" size="small">Parcial</Badge>
                                </div>
                              ) : (
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => { e.stopPropagation(); openConcilFromInvoice(inv); }}
                                >
                                  <Badge tone="critical" size="small">Sin pago</Badge>
                                </div>
                              )}
                            </InlineGrid>
                          </div>
                        );
                      })}
                    </BlockStack>
                  </Card>
                )}

                {/* Cancellation reason */}
                {resDetails.cancel_reason && (
                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingSm" tone="critical">Motivo de Cancelación</Text>
                      <Text variant="bodySm">{resDetails.cancel_reason}</Text>
                    </BlockStack>
                  </Card>
                )}

                {/* Audit History */}
                <Card>
                  <BlockStack gap="300">
                    <Text variant="headingMd">Historial</Text>
                    <BlockStack gap="200">
                      <TextField
                        label="Comentario"
                        labelHidden
                        value={auditComment}
                        onChange={setAuditComment}
                        placeholder="Escribe un comentario..."
                        multiline={2}
                      />
                      <div>
                        <Button
                          onClick={addAuditComment}
                          disabled={!auditComment.trim()}
                        >
                          Comentar
                        </Button>
                      </div>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="200">
                      {auditLog.map((entry) => (
                        <div
                          key={entry.id}
                          style={{
                            paddingBottom: "0.5rem",
                            borderBottom: "1px solid var(--p-color-border-secondary)",
                          }}
                        >
                          <InlineGrid columns="1fr auto">
                            <Text variant="bodySm" fontWeight="semibold">
                              {entry.user?.name || "Sistema"}
                            </Text>
                            <Text variant="bodySm" tone="subdued">
                              {formatDate(entry.created_at?.substring(0, 10))}
                            </Text>
                          </InlineGrid>
                          {entry.action === "comment" ? (
                            <div
                              style={{
                                background: "var(--p-color-bg-fill-tertiary)",
                                padding: "0.25rem 0.5rem",
                                borderRadius: "4px",
                                marginTop: "0.25rem",
                              }}
                            >
                              <Text variant="bodySm">{entry.comment}</Text>
                            </div>
                          ) : (
                            <Text variant="bodySm" tone="subdued">
                              {entry.action === "status_change"
                                ? `Cambió estado: ${entry.changes?.from || ""} → ${entry.changes?.to || ""}`
                                : entry.action}
                              {entry.comment && ` — ${entry.comment}`}
                            </Text>
                          )}
                        </div>
                      ))}
                      {auditLog.length === 0 && (
                        <Text variant="bodySm" tone="subdued">Sin actividad</Text>
                      )}
                    </BlockStack>
                  </BlockStack>
                </Card>
              </BlockStack>
            </Layout.Section>
          </Layout>
        </Page>
      ) : (
        ""
      )}
    </AppWrapper>
  );
}

export default Reservation;
